// import React, { useState, useEffect, useRef } from "react";
// import { Button } from "../../Components/ui/button";
// import { Input } from "../../Components/ui/input";
// import { Badge } from "../../Components/ui/badge";
// import { AlertTriangle } from "lucide-react";
// import {
//   CalendarIcon,
//   CaretSortIcon,
//   ArrowRightIcon,
//   DotsHorizontalIcon,
// } from "@radix-ui/react-icons";
// import { format } from "date-fns";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "../../Components/ui/popover";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "../../Components/ui/table";
// import { Calendar } from "../../Components/ui/calendar";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// // import { ToastContainer, toast } from "react-toastify";
// import { Toaster } from "../../Components/ui/toaster";
// import { toast, useToast } from "../../Components/ui/use-toast";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import { CircularProgress } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import { RootState } from "../../State/store";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "../../Components/ui/dropdown-menu";
// import { DateRange } from "react-day-picker";
// import { setCreateBreadCrumb } from "../../State/slices/AdvertiserAccountSlice";
// import {
//   CampaignProvider,
//   useCampaignContext,
// } from "./CreateCampaign/CampaignContext";
// import { convertUTCToLocal } from "../../../src/utils/convertUTCToLocal";
// import { RowData } from "./CreateCampaign/CampaignContext";
// import { setSelectedFromCountryISOs } from "../../State/slices/AdvertiserAccountSlice";
// import { Tabs, TabsList, TabsTrigger } from "../../../src/Components/ui/tabs";
// import AdvertiserCampaignListDropdown from "../../Components/Filter/AdvertiserCampaignListDropdown";
// import TestModeDialog from "./TestMode";

// interface Campaign {
//   user_account_id: number;
//   campaign_id: number;
//   // advertiser_workspace_id: number;
//   campaign_name: string;
//   advertiser_workspace_id: number;
//   admin_approval: string;
//   status: string;
//   start_date: string;
//   end_date: string;
//   channels: (string | null)[];
//   traveller_count_total: number;
//   total_sent_count: number;
//   total_messages_sent: number;
//   status_preview?: string;
//   total_delivery_count: number;
//   delivered_whatsapp_count: number;
//   delivered_sms_count: number;
//   created_date: string;
// }

// interface Country {
//   country_name: string;
//   country_code: string;
//   country_iso: string;
// }

// interface Draft {
//   draft_id: number;
//   workspace_id: number;
//   campaign_name: string;
//   channels: (string | null)[];
//   start_date: string;
//   end_date: string;
//   total_travellers: number;
//   created_time: string;
// }

// // Channel carousel
// const ChannelCarousel: React.FC<{ channels?: (string | null)[] }> = ({
//   channels = [],
// }) => {
//   const filteredChannels = Array.isArray(channels)
//     ? (channels.filter(Boolean) as string[])
//     : [];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isSliding, setIsSliding] = useState(true);
//   const badgeRefs = useRef<(HTMLDivElement | null)[]>([]);
//   const [offsets, setOffsets] = useState<number[]>([]);

//   useEffect(() => {
//     if (filteredChannels.length > 1) {
//       const t = setTimeout(() => {
//         const allOffsets: number[] = [];
//         let sum = 0;
//         for (let i = 0; i < filteredChannels.length; i++) {
//           allOffsets.push(sum);
//           const w = badgeRefs.current[i]?.offsetWidth ?? 0;
//           sum += w + 2;
//         }
//         setOffsets(allOffsets);
//       }, 0);
//       return () => clearTimeout(t);
//     }
//   }, [filteredChannels.length, filteredChannels.join("|")]); // ← safe

//   useEffect(() => {
//     if (filteredChannels.length <= 1) return;
//     let timeout: ReturnType<typeof setTimeout>;
//     if (isSliding) {
//       timeout = setTimeout(() => setIsSliding(false), 4000);
//     } else {
//       timeout = setTimeout(() => {
//         setCurrentIndex((prev) => (prev + 1) % filteredChannels.length);
//         setIsSliding(true);
//       }, 1000);
//     }
//     return () => clearTimeout(timeout);
//   }, [isSliding, filteredChannels.length]);

//   if (filteredChannels.length === 0)
//     return <span className="text-gray-400">-</span>;

//   if (filteredChannels.length === 1) {
//     const channel = filteredChannels[0];
//     return (
//       <div className="flex items-center h-7">
//         <Badge
//           className={
//             channel === "WhatsApp"
//               ? ""
//               : channel === "SMS"
//                 ? ""
//                 : channel === "Push Notification" || channel === "Push"
//                   ? ""
//                   : channel === "Email"
//                     ? "bg-blue-400"
//                     : "bg-gray-400"
//           }
//           style={
//             channel === "WhatsApp"
//               ? { backgroundColor: "#479E98", color: "#fff" }
//               : channel === "SMS"
//                 ? { backgroundColor: "#DFA548", color: "#fff" }
//                 : channel === "Push Notification" || channel === "Push"
//                   ? { backgroundColor: "#B87867", color: "#fff" }
//                   : channel === "RCS" || channel === "RCS messages"
//                     ? { backgroundColor: "#61177E", color: "#fff" }
//                     : {}
//           }
//         >
//           {channel}
//         </Badge>
//       </div>
//     );
//   }

//   return (
//     <div className="relative h-7 w-[120px] overflow-hidden">
//       <div
//         className="flex items-center"
//         style={{
//           gap: "2px",
//           transform: `translateX(-${offsets[currentIndex] ?? 0}px)`,
//           transition: isSliding
//             ? "transform 4s cubic-bezier(0.5,0,0.5,1)"
//             : "none",
//         }}
//       >
//         {filteredChannels.map((channel, idx) => (
//           <div
//             key={`${channel}-${idx}`}
//             ref={(el) => (badgeRefs.current[idx] = el)}
//             className="flex items-center"
//             style={{ margin: 0, padding: 0 }}
//           >
//             <Badge
//               className={
//                 channel === "WhatsApp"
//                   ? ""
//                   : channel === "SMS"
//                     ? ""
//                     : channel === "Push Notification" || channel === "Push"
//                       ? ""
//                       : channel === "Email"
//                         ? "bg-blue-400"
//                         : "bg-gray-400"
//               }
//               style={
//                 channel === "WhatsApp"
//                   ? { backgroundColor: "#479E98", color: "#fff" }
//                   : channel === "SMS"
//                     ? { backgroundColor: "#DFA548", color: "#fff" }
//                     : channel === "Push Notification" || channel === "Push"
//                       ? { backgroundColor: "#B87867", color: "#fff" }
//                       : channel === "RCS" || channel === "RCS messages"
//                         ? { backgroundColor: "#61177E", color: "#fff" }
//                         : {}
//               }
//             >
//               {channel}
//             </Badge>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const StatusPreviewBadge: React.FC<{
//   value?: string;
//   onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
// }> = ({ value, onClick }) => {
//   const raw = (value ?? "").trim();
//   const hasWarning = /with warning symbol/i.test(raw);
//   const base = raw.replace(/with warning symbol/ig, "").trim();

//   // normalize variants
//   const norm = base.toLowerCase().replace(/\s+/g, " ");

//   type Key = "live" | "partially live" | "completed" | "in review" | "rejected" | "pending";
//   const key: Key =
//     norm === "live" ? "live" :
//       norm === "partially live" || norm === "partialy live" ? "partially live" :
//         norm === "completed" ? "completed" :
//           norm === "in review" || norm === "inreview" ? "in review" :
//             norm === "rejected" ? "rejected" : "pending";

//   // fixed colors (no hover color change)
//   let colorClasses = "";
//   switch (key) {
//     case "live":
//       colorClasses = "!bg-green-700 text-white hover:!bg-green-700 hover:text-white";
//       break;
//     case "partially live":
//       colorClasses = "!bg-green-300 text-gray-900 hover:!bg-green-300 hover:text-gray-900";
//       break;
//     case "completed":
//       colorClasses = "!bg-blue-600 text-white hover:!bg-blue-600 hover:text-white";
//       break;
//     case "in review":
//       colorClasses = "!bg-yellow-400 text-gray-900 hover:!bg-yellow-400 hover:text-gray-900";
//       break;
//     case "rejected":
//       colorClasses = "!bg-red-600 text-white hover:!bg-red-600 hover:text-white";
//       break;
//     case "pending":
//     default:
//       colorClasses = "!bg-gray-400 text-white hover:!bg-gray-400 hover:text-white";
//       break;
//   }

//   const label = key.replace(/\b\w/g, c => c.toUpperCase());

//   // subtle hover/focus effect (no color change)
//   const hoverFx =
//     "transform-gpu transition-transform duration-200 ease-out " +
//     "hover:scale-[1.08] focus-visible:scale-[1.05] active:scale-100 " +
//     "hover:shadow-lg";

//   return (
//     <button
//       type="button"
//       onClick={(e) => { e.stopPropagation(); onClick?.(e); }}
//       className="inline-flex items-center gap-1 p-0 m-0 bg-transparent hover:bg-transparent focus:outline-none focus:ring-0 cursor-pointer"
//       aria-label={`Open campaign status (${label}${hasWarning ? " – warning" : ""})`}
//       title="View status details"
//     >
//       <Badge
//         className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium select-none ${colorClasses} ${hoverFx}`}
//       >
//         <span>{label}</span>
//       </Badge>
//       {hasWarning && (
//         <AlertTriangle size={20} className="ml-1 text-red-600" aria-hidden="true" />
//       )}
//     </button>
//   );
// };

// const DatePickerWithRange: React.FC<{
//   dateRange: DateRange | undefined;
//   setDateRange: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
//   setInitialCampaign: React.Dispatch<React.SetStateAction<boolean>>;
//   setIsClearingDate: React.Dispatch<React.SetStateAction<boolean>>;
// }> = ({ dateRange, setDateRange, setInitialCampaign, setIsClearingDate }) => (
//   <Popover>
//     <PopoverTrigger asChild>
//       <Button
//         variant="outline"
//         className="min-w-[150px] w-auto justify-start text-left font-normal mt-0"
//       >
//         <CalendarIcon className="mr-2 h-4 w-4" />
//         {dateRange?.from ? (
//           dateRange.to ? (
//             <>
//               {format(dateRange.from, "LLL dd, y")} -{" "}
//               {format(dateRange.to, "LLL dd, y")}
//             </>
//           ) : (
//             format(dateRange.from, "LLL dd, y")
//           )
//         ) : (
//           <span>Pick a date</span>
//         )}
//       </Button>
//     </PopoverTrigger>
//     <PopoverContent className="w-auto p-0" align="start">
//       <Calendar
//         initialFocus
//         mode="range"
//         defaultMonth={dateRange?.from ?? new Date()}
//         selected={dateRange}
//         onSelect={(range: DateRange | undefined) => {
//           if (
//             !range?.from &&
//             !range?.to &&
//             (dateRange?.from || dateRange?.to)
//           ) {
//             setIsClearingDate(true);
//           }
//           setDateRange(range);
//           if ((range?.from && range?.to) || (!range?.from && !range?.to)) {
//             setInitialCampaign(false);
//           }
//         }}
//         numberOfMonths={1}
//       />
//     </PopoverContent>
//   </Popover>
// );

// const CampaignList: React.FC = () => {
//   // Redux/selectors
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const workspaceId = useSelector(
//     (state: RootState) => state.authentication.workspace_id
//   ); // HARDCODED for demo
//   const userPermissions = useSelector(
//     (state: RootState) => state.advertiserAccount.permissions
//   );
//   const apiUrlAdvAcc = useSelector(
//     (state: RootState) => state.authentication.apiURL
//   );
//     const apiUrlAdminAcc = useSelector(
//     (state: RootState) => state.authentication.adminUrl
//   );

//   // State
//   const [campaignList, setCampaignList] = useState<Campaign[]>([]);

//   const accountId = useSelector((state: RootState) => state.authentication.account_id);

//   const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
//   const [checkboxSelectedRows, setCheckboxSelectedRows] = useState<number[]>(
//     []
//   );
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [rowsPerPage, setRowsPerPage] = useState<number>(10);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [totalCount, setTotalCount] = useState(0);
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [campaignLoading, setCampaignLoading] = useState(true);
//   const [isInternalDialogOpen, setInternalDialogOpen] = useState(false);
//   const [isApiExecuting, setIsApiExecuting] = useState(false);
//   const [campaignToDelete, setCampaignToDelete] = useState<number | null>(null);
//   const [dateRange, setDateRange] = useState<DateRange | undefined>();
//   const [initialcampaign, setInitialCampaign] = useState(true);
//   const [isClearingDate, setIsClearingDate] = useState(false);

//   const [detailedSummaryModal, setDetailedSummaryModal] = useState<{
//     isOpen: boolean;
//     campaign: Campaign | null;
//   }>({ isOpen: false, campaign: null });

//   const [sortField, setSortField] = useState<string | null>(null);
//   const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

//   const workspaceTimezone = useSelector((state: RootState) => state.authentication.workspaceTimezone);

//   const [walletstatus, setWalletStatus] = useState<boolean>();

//   const [isCampaignListLoading, setIsCampaignListLoading] = useState<boolean>(false);

//   // Draft State
//   const [draftList, setDraftList] = useState<Draft[]>([]);
//   const [totalDraftCount, setTotalDraftCount] = useState(0);
//   const [draftLoading, setDraftLoading] = useState(false);

//   const [isDraftEnabled, setIsDraftEnabled] = useState(false);
//   const toggleDraft = () => {
//     setIsDraftEnabled(!isDraftEnabled);
//   };

//   const [activeTab, setActiveTab] = useState("List");
//   const [isTestModeOpen, setIsTestModeOpen] = useState(false);
//   const [testModeCampaignId, setTestModeCampaignId] = useState<number | null>(null);

//   // const handleTabChange = (tab: string) => {
//   //   setActiveTab(tab);
//   // };

//   // useEffect(() => {
//   //   setTimeout(() => {
//   //     document.body.style.pointerEvents = "";
//   //   }, 500);
//   //   setActiveTab("basic");
//   // }, [activeTab]);

//   const {
//     campaignName,
//     fromCountries,
//     toCountry,
//     campaignStartDate,
//     campaignEndDate,
//     startTime,
//     endTime,
//     campaignDesc,
//     allocationType,
//     setAllocationType,
//     isDuplicatePrevented,
//     whatsappData,
//     smsData,
//     whatsappContent,
//     smsContent,
//     isPremiumOnly,
//     selectedToCountryISO,
//     fromCountryISOs,
//     setCampaignNameError,
//     setFromCountryError,
//     setToCountryError,
//     setContentError,
//     setStartDateError,
//     setEndDateError,
//     setEndTimeError,
//     setStartTimeError,
//     setIsSubmitAttempted,
//     selectedToCountryCode,
//     selectedFromCountryCodes,
//     selectedTimeZone,
//     setWhatsappContent,
//     setSmsContent,
//     setSelectedTimeZone,
//     timezoneOptions,
//     setBody,
//     setLanguage,
//     setMediaBase64,
//     setHeaderType,
//     setSelectedOption,
//     setTextInput,
//     setBodyText,
//     setFooterText,
//     setRows,
//     setFromCountryISOsFromAPI,
//     setToCountryISOFromAPI,
//     setUpdateModeTravellerCount,
//     setFileType,
//     setFileLength,
//     setFileName,
//     setPreviewImage,
//     setSelectedFile,
//     countValidationAgainstEachCountry,
//     hasInsufficientMessages,
//     setPartsCount,
//     setShowWarning,
//     setMediaConfig,
//     setLoading,
//     setUpdateCampaignId,
//     resetCampaign,
//     resetSMSContent,
//     resetWhatsappContent,
//     setIsUpdateMode,
//     isUpdateMode,
//     setCampaignName,
//     setEndTime,
//     setStartTime,
//     setCampaignEndDate,
//     setCampaignStartDate,
//     setIsPremiumOnly,
//     setIsDuplicatePrevented,
//     setFromCountryCodeMap,
//     setFromCountryISOs,
//     setFromCountryOptions,
//     setCountries,
//     setSelectedFromCountryCodes,
//     setFromCountries,
//     FromCountryOptions,
//     setToCountry,
//     setSelectedToCountryCode,
//     setSelectedToCountryISO,
//     setIsDraftMode,
//     setDraftModeTravellerCount,
//     isViewMode,
//     setIsViewMode,
//     setIsTestMode
//   } = useCampaignContext();

//   const selectedFromCountryISOs = useSelector(
//     (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
//   );

//   const isImpersonated = useSelector(
//     (state: RootState) => state.admin.Impersonator?.ImpersonationState
//   );
//   const impersonatorAID = useSelector(
//     (state: RootState) => state.admin.Impersonator?.ImpersonatorAID
//   );

//   const toast = useToast();

//   const [filterData, setFilterData] = useState<{ filter: string; value: string }>({
//     filter: "None",
//     value: "",
//   });

//   const getDraftList = async () => {
//     if (!workspaceId || !apiUrlAdvAcc) return;
//     setDraftLoading(true); // separate loading state for drafts
//     try {
//       const params: any = {
//         workspaceId,
//         page: currentPage,           // reused existing pagination state
//         rowsPerPage,                 // reused existing pagination state
//         searchTerm: debouncedSearchTerm || undefined, // reused existing debounced search
//       };

//       // Optional: include dates if desired (shared dateRange state)
//       if (dateRange?.from && dateRange?.to) {
//         params.startDate = format(dateRange.from, "yyyy-MM-dd");
//         params.endDate = format(dateRange.to, "yyyy-MM-dd");
//       }

//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetAllCampaignDraftsByWorkspaceId/${workspaceId}`,
//         { params }
//       );
//       if (response.data.status === "Success") {
//         setDraftList(response.data.draftList || []);
//         setTotalDraftCount(response.data.distinctDraftCount || 0);

//       } else {
//         setDraftList([]);
//         setTotalDraftCount(0);
//       }

//     } catch {
//       setDraftList([]);
//       setTotalDraftCount(0);
//     } finally {
//       setDraftLoading(false);
//     }
//   };

//   // Fetch
//   const getCampaignList = async () => {
//     if (!workspaceId || !apiUrlAdvAcc) return;
//     setCampaignLoading(true);
//     try {
//       const params: any = {
//         workspaceId,
//         page: currentPage,
//         rowsPerPage,
//         searchTerm: debouncedSearchTerm || undefined,
//         filter: filterData.filter !== "None" ? filterData.filter : undefined,
//         subFilter: filterData.filter !== "None" ? filterData.value : undefined,
//       };
//       if (dateRange?.from && dateRange?.to) {
//         params.startDate = format(dateRange.from, "yyyy-MM-dd");
//         params.endDate = format(dateRange.to, "yyyy-MM-dd");
//       }
//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetCampaignListbyWorkspaceId/${workspaceId}`,
//         { params }
//       );
//       if (response.data.status === "Success") {
//         setCampaignList(response.data.campaignList || []);
//         setTotalCount(response.data.distinctCampaignCount || 0);
//       } else {
//         setCampaignList([]);
//         setTotalCount(0);
//       }
//     } catch {
//       setCampaignList([]);
//       setTotalCount(0);
//     } finally {
//       setCampaignLoading(false);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (searchTerm !== debouncedSearchTerm) return;
//     getCampaignList(); /* eslint-disable-next-line */
//     getDraftList();
//   }, [workspaceId, currentPage, rowsPerPage, debouncedSearchTerm, dateRange, filterData]);

//   useEffect(() => {
//     const d = setTimeout(() => setDebouncedSearchTerm(searchTerm), 500);
//     return () => clearTimeout(d);
//   }, [searchTerm]);

//   // Checkbox/Select
//   const handleCheckboxRowSelect = (id: number) => {
//     setCheckboxSelectedRows((prev) => {
//       const newSelectedRows = prev.includes(id)
//         ? prev.filter((rowId) => rowId !== id)
//         : [...prev, id];
//       setIsAllSelected(newSelectedRows.length === campaignList.length);
//       return newSelectedRows;
//     });
//   };
//   const handleSelectAll = () => {
//     if (isAllSelected) setCheckboxSelectedRows([]);
//     else setCheckboxSelectedRows(campaignList.map((c) => c.campaign_id));
//     setIsAllSelected(!isAllSelected);
//   };

//   const formatCreated = (v?: string) =>
//     v ? v.replace("T", " ").split(".")[0] : "-";

//   const toMs = (v: any) => (v ? new Date(String(v).replace(" ", "T")).getTime() : 0);

//   // Sorting
//   const sortCampaignList = (field: string) => {
//     let type: "string" | "number" | "date" = "string";
//     switch (field) {
//       case "ByCampaignName":
//         type = "string";
//         break;
//       case "ByCampaignStatus":
//         type = "string";
//         break;
//       case "ByCampaignDate":
//         type = "date";
//         break;
//       case "ByTotalTravellers":
//         type = "number";
//         break;
//       case "ByCampaignSent":
//         type = "number";
//         break;
//       case "ByMessagesSent":
//         type = "number";
//         break;
//       case "ByCreatedDate":           // 🔹 NEW
//         type = "date";
//         break;
//       default:
//         break;
//     }

//     let direction: "asc" | "desc" = "asc";
//     if (sortField === field) direction = sortDirection === "asc" ? "desc" : "asc";
//     setSortField(field);
//     setSortDirection(direction);

//     const sorted = [...campaignList].sort((a, b) => {
//       let aValue: any, bValue: any;
//       switch (field) {
//         case "ByCampaignName":
//           aValue = a.campaign_name || "";
//           bValue = b.campaign_name || "";
//           break;
//         case "ByCampaignStatus":
//           aValue = a.status || "";
//           bValue = b.status || "";
//           break;
//         case "ByCampaignDate":
//           aValue = a.start_date;
//           bValue = b.start_date;
//           break;
//         case "ByTotalTravellers":
//           aValue = a.traveller_count_total || 0;
//           bValue = b.traveller_count_total || 0;
//           break;
//         case "ByCampaignSent":
//           aValue = a.total_sent_count || 0;
//           bValue = b.total_sent_count || 0;
//           break;
//         case "ByMessagesSent":
//           aValue = a.total_messages_sent || 0;
//           bValue = b.total_messages_sent || 0;
//           break;
//         case "ByCreatedDate":          // 🔹 NEW
//           aValue = a.created_date || "";
//           bValue = b.created_date || "";
//           break;
//         default:
//           return 0;
//       }

//       if (type === "number") {
//         return direction === "asc" ? aValue - bValue : bValue - aValue;
//       } else if (type === "date") {
//         const aMs = toMs(aValue);
//         const bMs = toMs(bValue);
//         return direction === "asc" ? aMs - bMs : bMs - aMs;
//       } else {
//         return direction === "asc"
//           ? String(aValue).localeCompare(String(bValue))
//           : String(bValue).localeCompare(String(aValue));
//       }
//     });

//     setCampaignList(sorted);
//   };

//   const getWalletStatusByWorkspaceId = async (): Promise<boolean | null> => {
//     try {
//       setIsCampaignListLoading(true);
//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetWorkspaceWalletStatusByWorkspaceId`,
//         {
//           params: { workspaceInfoId: workspaceId },
//         }
//       );

//       if (response.data?.status === "Success") {
//         const walletStatus = response.data.wallet_status;
//         return walletStatus; // ✅ this is crucial
//       } else {
//         setIsCampaignListLoading(false);
//         return null;
//       }
//     } catch (error) {
//       setIsCampaignListLoading(false);
//       console.error("Error retrieving wallet status:", error);
//       return null;
//     }
//   };

//   const GetFromCountries = async () => {
//     try {
//       setIsCampaignListLoading(true);
//       const response = await axios.get(`${apiUrlAdvAcc}/GetFromCountries`);
//       if (
//         response.data?.status === "Success" &&
//         Array.isArray(response.data.fromCountries)
//       ) {
//         const countries = response.data.fromCountries as Country[];
//         setCountries(countries);
//         const dropdownOptions = countries.map((c) => ({
//           label: c.country_name,
//           value: c.country_name,
//         }));

//         const isoMap = countries.reduce<{ [name: string]: string }>(
//           (acc, c) => {
//             acc[c.country_name] = c.country_iso;
//             return acc;
//           },
//           {}
//         );

//         const codeMap = countries.reduce<{ [iso: string]: string }>(
//           (acc, c) => {
//             acc[c.country_iso] = c.country_code;
//             return acc;
//           },
//           {}
//         );

//         setFromCountryOptions(dropdownOptions);
//         setFromCountryISOs(isoMap);
//         setFromCountryCodeMap(codeMap);
//       }
//     } catch (err) {
//       setIsCampaignListLoading(false);
//       console.log("Error :", err);
//     } finally {
//       // setLoading(false); // Always runs
//     }
//   };

//   // Update your GetCampaignDraftByWorkspaceId function to include template loading
//   const GetCampaignDraftByWorkspaceId = async (workspaceId: number, draftId: number) => {
//     try {
//       setIsCampaignListLoading(true);
//       // const response = await axios.get(
//       //   `${apiUrlAdvAcc}/GetCampaignDraftByWorkspaceId?workspaceId=${workspaceId}`
//       // );
//       const response = await axios.get(
//         `${apiUrlAdvAcc}/GetCampaignDraftByWorkspaceId?workspaceId=${workspaceId}&draftId=${draftId}`
//       );

//       if (
//         response.data?.status !== "Success" ||
//         !response.data?.draftData ||
//         response.data.draftData === "{}"
//       ) {
//         console.warn("No campaign draft found for workspaceId:", workspaceId);
//         return null;
//       }

//       const draft = JSON.parse(response.data.draftData);
//       const details = draft?.campaigndetails ?? {};
//       const templates = draft?.templatedetails ?? {}; // NEW: Extract template details

//       if (
//         (details.total_traveller_count?.sms_count?.length ?? 0) === 0 &&
//         (details.total_traveller_count?.whatsapp_count?.length ?? 0) === 0
//       ) {
//         console.warn("No campaign draft found for workspaceId:", workspaceId);
//         return null;
//       }

//       // ============= EXISTING CAMPAIGN DETAILS EXTRACTION =============
//       setCampaignName(details.campaign_name ?? "");
//       setCampaignStartDate(details.campaign_start_date ?? "");
//       setCampaignEndDate(details.campaign_end_date ?? "");
//       setStartTime(details.start_time ?? "");
//       setEndTime(details.end_time ?? "");
//       setAllocationType(details.allocation_type ?? "Lifetime Allocation");
//       //setRoamingDays(String(draft?.campaigndetails?.roaming_days ?? 1));
//       setIsDuplicatePrevented(details.is_duplicate_prevented ?? true);
//       setIsPremiumOnly(details.is_premium_only ?? false);

//       // ISOs, Dial codes, Names
//       // setSelectedFromCountryISOs(draft.campaigndetails.selectedFromCountryISOs);

//       dispatch(
//         setSelectedFromCountryISOs(
//           draft.campaigndetails.selectedFromCountryISOs
//         )
//       );
//       setSelectedFromCountryCodes(draft.campaigndetails.from_countries);
//       setFromCountries(draft.campaigndetails.fromCountries);
//       setToCountry(draft.campaigndetails.toCountry);
//       setSelectedToCountryISO(draft.campaigndetails.selectedToCountryISO);
//       setSelectedToCountryCode(draft.campaigndetails.to_country);
//       setIsTestMode(draft.campaigndetails.is_test_mode ?? false);

//       // Traveller count
//       if (draft.campaigndetails.total_traveller_count) {
//         setDraftModeTravellerCount(draft.campaigndetails.total_traveller_count);
//         setIsDraftMode(true);
//       }

//       // ============= NEW: TEMPLATE LOADING SECTION =============

//       // ✅ Helper function to convert base64 to real File object (same as update mode)
//       const base64ToFile = (
//         base64String: string,
//         fileName: string,
//         fileType: string
//       ): File => {
//         const base64Data = base64String.includes(",")
//           ? base64String.split(",")[1]
//           : base64String;
//         const byteCharacters = atob(base64Data);
//         const byteNumbers = new Array(byteCharacters.length);

//         for (let i = 0; i < byteCharacters.length; i++) {
//           byteNumbers[i] = byteCharacters.charCodeAt(i);
//         }

//         const byteArray = new Uint8Array(byteNumbers);
//         const blob = new Blob([byteArray], { type: fileType });
//         return new File([blob], fileName, { type: fileType });
//       };

//       // 🔹 Load WhatsApp Template from Draft
//       if (templates.whatsappContent?.template) {
//         const whatsappTemplate = templates.whatsappContent.template;
//         const content = whatsappTemplate.template_content;

//         console.log("📱 WhatsApp Template Found in Draft:", {
//           whatsappTemplate,
//           content,
//         });

//         // ✅ Set complete WhatsApp content to context
//         setWhatsappContent(templates.whatsappContent);

//         // ✅ Set media config states
//         const mediaConfig = whatsappTemplate.media_config || {};
//         setMediaBase64(mediaConfig.binary_data || "");
//         setFileName(mediaConfig.file_name || "");
//         setFileLength(mediaConfig.file_length || "");
//         setFileType(mediaConfig.file_type || "");

//         // ✅ Set combined media config state
//         setMediaConfig({
//           file_name: mediaConfig.file_name || "",
//           file_type: mediaConfig.file_type || "",
//           binary_data: mediaConfig.binary_data || "",
//           file_length: mediaConfig.file_length || "",
//         });

//         // ✅ Set language
//         setLanguage(content.language || "");

//         // 🔹 Parse components from string
//         let components = [];
//         try {
//           components = JSON.parse(content.components || "[]");
//         } catch (e) {
//           console.warn("Failed to parse WhatsApp components:", e);
//           components = [];
//         }

//         // 🔸 HEADER Component
//         const headerComponent = components.find(
//           (comp: any) => comp.type === "HEADER"
//         );
//         if (headerComponent && headerComponent.format) {
//           const apiFormat = headerComponent.format;

//           switch (apiFormat.toUpperCase()) {
//             case "TEXT":
//               setHeaderType("text");
//               setSelectedOption("text");
//               setTextInput(headerComponent.text || "");
//               break;

//             case "IMAGE":
//               setHeaderType("image");
//               setSelectedOption("image");
//               if (
//                 mediaConfig.binary_data &&
//                 mediaConfig.binary_data.trim() !== ""
//               ) {
//                 setPreviewImage(mediaConfig.binary_data);
//                 const realImageFile = base64ToFile(
//                   mediaConfig.binary_data,
//                   mediaConfig.file_name,
//                   mediaConfig.file_type
//                 );
//                 setSelectedFile(realImageFile);
//               }
//               break;

//             case "VIDEO":
//               setHeaderType("video");
//               setSelectedOption("video");
//               if (
//                 mediaConfig.binary_data &&
//                 mediaConfig.binary_data.trim() !== ""
//               ) {
//                 const realVideoFile = base64ToFile(
//                   mediaConfig.binary_data,
//                   mediaConfig.file_name,
//                   mediaConfig.file_type
//                 );
//                 setSelectedFile(realVideoFile);
//               }
//               break;

//             case "DOCUMENT":
//               setHeaderType("document");
//               setSelectedOption("document");
//               if (
//                 mediaConfig.binary_data &&
//                 mediaConfig.binary_data.trim() !== ""
//               ) {
//                 const realDocFile = base64ToFile(
//                   mediaConfig.binary_data,
//                   mediaConfig.file_name,
//                   mediaConfig.file_type
//                 );
//                 setSelectedFile(realDocFile);
//               }
//               break;

//             default:
//               setHeaderType("none");
//               setSelectedOption("none");
//           }
//         } else {
//           setHeaderType("none");
//           setSelectedOption("none");
//         }

//         // 🔸 BODY Component
//         const bodyComponent = components.find(
//           (comp: any) => comp.type === "BODY"
//         );
//         if (bodyComponent) {
//           setBodyText(bodyComponent.text || "");
//         }

//         // 🔸 FOOTER Component
//         const footerComponent = components.find(
//           (comp: any) => comp.type === "FOOTER"
//         );
//         if (footerComponent) {
//           setFooterText(footerComponent.text || "");
//         }

//         // 🔸 BUTTONS Component
//         const buttonComponent = components.find(
//           (comp: any) => comp.type === "BUTTONS"
//         );
//         if (buttonComponent?.buttons?.length > 0) {
//           const transformedRows: RowData[] = buttonComponent.buttons.map(
//             (btn: any) => {
//               if (btn.type === "URL") {
//                 return {
//                   buttonType: "URL",
//                   buttonText: btn.text,
//                   buttonTypeDropdown: "static",
//                   websiteUrl: btn.url,
//                   callPhoneNumber: "",
//                   countryCode: "",
//                   copyOfferCode: "",
//                 };
//               } else if (btn.type === "PHONE_NUMBER") {
//                 const phone = btn.phone_number || "";
//                 const phoneStr = phone.toString();
//                 const countryCode =
//                   phoneStr.length > 10 ? phoneStr.slice(0, -10) : "";
//                 const phoneNumber =
//                   phoneStr.length > 10 ? phoneStr.slice(-10) : phoneStr;

//                 return {
//                   buttonType: "PHONE_NUMBER",
//                   buttonText: btn.text,
//                   buttonTypeDropdown: "static",
//                   callPhoneNumber: phoneNumber,
//                   countryCode: countryCode,
//                   websiteUrl: "",
//                   copyOfferCode: "",
//                 };
//               } else if (btn.type === "COPY_CODE") {
//                 return {
//                   buttonType: "COPY_CODE",
//                   buttonText: "Copy",
//                   buttonTypeDropdown: "static",
//                   websiteUrl: "",
//                   callPhoneNumber: "",
//                   countryCode: "",
//                   copyOfferCode: btn.example || "",
//                 };
//               } else if (btn.type === "QUICK_REPLY") {
//                 return {
//                   buttonType: "QUICK_REPLY",
//                   buttonText: btn.text,
//                   buttonTypeDropdown: "static",
//                   websiteUrl: "",
//                   callPhoneNumber: "",
//                   countryCode: "",
//                   copyOfferCode: "",
//                 };
//               }

//               return {
//                 buttonType: "",
//                 buttonText: "",
//                 buttonTypeDropdown: "static",
//                 websiteUrl: "",
//                 callPhoneNumber: "",
//                 countryCode: "",
//                 copyOfferCode: "",
//               };
//             }
//           );

//           setRows(transformedRows);
//         } else {
//           setRows([]);
//         }

//         console.log("✅ WhatsApp Content loaded from draft:", {
//           completeTemplate: templates.whatsappContent,
//           mediaConfig: mediaConfig,
//           components: components.length,
//         });
//       } else {
//         console.warn("⚠️ WhatsApp template not found in draft");
//         // Reset WhatsApp states
//         setWhatsappContent(null);
//         setMediaConfig({
//           file_name: "",
//           file_type: "",
//           binary_data: "",
//           file_length: "",
//         });
//         setMediaBase64("");
//         setFileName("");
//         setFileLength("");
//         setFileType("");
//         setHeaderType("none");
//         setSelectedOption("none");
//         setBodyText("");
//         setFooterText("");
//         setRows([]);
//       }

//       // 🔹 Load SMS Template from Draft
//       if (templates.smsContent?.template) {
//         const smsTemplate = templates.smsContent.template;
//         const smsContent = smsTemplate.template_content;

//         console.log("📱 SMS Template Found in Draft:", smsContent);

//         // ✅ Set SMS message body
//         setBody(smsContent.message || "");

//         // ✅ Set parts count from draft
//         setPartsCount(smsTemplate.part_count || 1);

//         // ✅ Set warning if parts > 1
//         setShowWarning(smsTemplate.part_count > 1);

//         // ✅ Set complete SMS content to context
//         setSmsContent(templates.smsContent);

//         console.log("✅ SMS Content loaded from draft:", {
//           message: smsContent.message,
//           partsCount: smsTemplate.part_count,
//           completeTemplate: templates.smsContent,
//         });
//       } else {
//         console.warn("⚠️ SMS template not found in draft");
//         // Reset SMS states
//         setBody("");
//         setPartsCount(1);
//         setShowWarning(false);
//         setSmsContent(null);
//       }

//       console.log(
//         "✅ Campaign draft retrieved with templates:",
//         details.campaign_name
//       );
//       return draft;
//     } catch (error) {
//       setIsCampaignListLoading(false);
//       console.error("Error fetching campaign draft:", error);
//       return null;
//     }
//   };

//   useEffect(() => {
//     console.log("heree", selectedFromCountryISOs);
//   }, [selectedFromCountryISOs]);

//   useEffect(() => {
//     setTimeout(() => {
//       document.body.style.pointerEvents = "";
//     }, 500);
//   }, [isTestModeOpen]);

//   // CRUD Actions

//   const handleCreateCampaign = async () => {
//     const status = await getWalletStatusByWorkspaceId();
//     await GetFromCountries();
//     // await GetCampaignDraftByWorkspaceId();
//     setIsCampaignListLoading(false);
//     if (!status) {
//       toast.toast({
//         title: "Alert",
//         description:
//           "Your wallet is not paired. Please pair your wallet to create a campaign.",
//       });
//       return;
//     }
//     // if (isUpdateMode || isViewMode) {
//     resetCampaign();
//     resetSMSContent();
//     resetWhatsappContent();
//     setUpdateCampaignId(null);
//     setIsUpdateMode(false);
//     setIsViewMode(false);
//     setIsDraftMode(false);
//     // }
//     dispatch(setCreateBreadCrumb(true));
//     navigate("/navbar/createcampaign");
//   };
//   const handleEdit = (campaignId: number) =>
//     navigate("/navbar/createcampaign", { state: { campaignId } });
//   const handleView = (campaignId: number) =>
//     navigate("/navbar/createcampaign", {
//       state: { viewModecampaignId: campaignId },
//     });
//   const handleInternalOpenDialog = (campaignId: number) => {
//     setCampaignToDelete(campaignId);
//     setTimeout(() => setInternalDialogOpen(true), 0);
//   };

//   // const toggleCampaignStatus = async (campaignId: number, action: string) => {
//   //   if (!campaignId || !action) return;

//   //   try {
//   //     const response = await axios.put(
//   //       `${apiUrlAdvAcc}/ToggleCampaignPauseResume`,
//   //       {
//   //         campaignId: campaignId,
//   //         action: action,
//   //       }
//   //     );

//   //     if (response.data.status === "Success") {
//   //       getCampaignList();

//   //       toast.toast({
//   //         title: "Success",
//   //         description: "The campaign status updated successfully",
//   //       });
//   //     } else {
//   //       toast.toast({
//   //         title: "Failur",
//   //         description: "Failed to update the campaign status",
//   //       });
//   //     }
//   //   } catch (error) {
//   //     toast.toast({
//   //       title: "Failure",
//   //       description:
//   //         "Something went wrong while trying to update the campaign status",
//   //     });
//   //   } finally {
//   //   }
//   // };
//  const toggleCampaignStatus = async (campaignId: number, action: string) => {
//     if (!campaignId || !action) return;

//     let toggleSuccess = false; // ✅ Flag to track toggle API result

//     try {
//       const response = await axios.put(`${apiUrlAdvAcc}/ToggleCampaignPauseResume`, {
//         campaignId: campaignId,
//         action: action,
//       });

//       if (response.data.status === "Success") {
//         toggleSuccess = true;

//         getCampaignList();

//         toast.toast({
//           title: "Success",
//           description: "The campaign status updated successfully",
//         });
//       } else {
//         toast.toast({
//           title: "Failure",
//           description: "Failed to update the campaign status",
//         });
//       }
//     } catch (error) {
//       toast.toast({
//         title: "Failure",
//         description: "Something went wrong while trying to update the campaign status",
//       });
//     } finally {
//       // 📝 Map action to readable values for audit log
//       const newStatus = action === "paused" ? "Paused" : "Resumed";
//       const comments =
//         action === "paused"
//           ? "Campaign paused by user"
//           : "Campaign resumed by user";
//       const actionLabel = action === "paused" ? "Campaign Paused" : "Campaign Resumed";

//       const auditDto = {
//         userAccountId: accountId,
//         campaignId: campaignId,
//         advertiserWorkspaceId: workspaceId,
//         action: actionLabel, // ✅ More readable action for audit
//         actionPage: "CampaignList",
//         status: toggleSuccess ? "Success" : "Failure",
//         beforeData: null, // will be fetched in API
//         afterData: JSON.stringify({ status: newStatus }),
//         ipAddress: null,
//         comments: comments,
//         ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null
//       };

//       try {
//         await axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, auditDto);
//         // ⚠️ Silent failure as decided
//       } catch (auditError) {
//         console.error("Audit logging failed", auditError);
//       }
//     }
//     return toggleSuccess; // ✅ Return the flag
//   };

//   const DeleteCampaignDraftByWorkspaceIdAndDraftId = async (workspaceId: number, draftId: number) => {
//     try {
//       const response = await axios.delete(
//         `${apiUrlAdvAcc}/DeleteCampaignDraftByWorkspaceIdAndDraftId?workspaceId=${workspaceId}&draftId=${draftId}`
//       );

//       if (response.data?.status === "Success") {
//         console.log(
//           `Draft deleted for workspaceId: ${workspaceId}, draftId: ${draftId}, deletedCount: ${response.data.deletedCount}`
//         );
//         toast.toast({
//           title: "Success",
//           description:
//             "Draft Deleted Successfully",
//         });
//         getDraftList();
//       } else {
//         console.warn(
//           `Failed to delete draft for workspaceId: ${workspaceId}, draftId: ${draftId}`,
//           response.data
//         );
//         toast.toast({
//           title: "Failure",
//           description:
//             "Failed to delete draft",
//         });
//         getDraftList();
//       }
//     } catch (error) {
//       console.error(
//         "Error deleting campaign draft by workspace ID and draft ID:",
//         error
//       );
//       toast.toast({
//         title: "Failure",
//         description:
//           "Failed to delete draft",
//       });
//       getDraftList();
//     }
//   };

//   const confirmDelete = async () => {
//     if (!campaignToDelete) return;
//     setIsApiExecuting(true);
//     try {
//       const response = await axios.delete(
//         `${apiUrlAdvAcc}/DeleteCampaignById`,
//         {
//           params: {
//             CampaignId: campaignToDelete,
//             ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null
//           }
//         }
//       );

//       const { status, status_Description } = response.data;

//       if (status === "Success") {
//         setInternalDialogOpen(false);
//         getCampaignList();
//         toast.toast({
//           title: "Success",
//           description: status_Description || "The campaign was deleted successfully",
//         });
//       } else {
//         setInternalDialogOpen(false);
//         getCampaignList();
//         toast.toast({
//           title: "Failure",
//           description: status_Description || "Failed to delete campaign",
//         });
//       }
//     } catch (error) {
//       setInternalDialogOpen(false);
//       getCampaignList();
//       toast.toast({
//         title: "Failure",
//         description: "Something went wrong while deleting the campaign.",
//       });
//       console.error("Delete campaign error:", error);
//     } finally {
//       setIsApiExecuting(false);
//     }
//   };

//   debugger;
//   const handleStatusNavigate = (campaign_id: number): void => {
//     navigate("/navbar/campaignstatusprogress", {
//       state: { campaign_id },
//     });
//   };

//   // // Pagination
//   // const totalPages: number = Math.ceil(totalDraftCount / rowsPerPage);

//   // Pagination
//   const totalPages: number = Math.max(1, Math.ceil(
//     (activeTab === "Draft" ? totalDraftCount : totalCount) / rowsPerPage
//   ));

//   // Export
//   const handleExportButtonClick = () => {
//     const filteredData = campaignList.map((c) => ({
//       campaign_id: c.campaign_id,
//       campaign_name: c.campaign_name,
//       channels: (c.channels || []).filter(Boolean).join(", "),
//       status: c.status,
//       start_date: c.start_date,
//       end_date: c.end_date,
//       total_traveller_count: c.traveller_count_total,
//       total_sent_count: c.total_sent_count,
//       total_messages_sent: c.total_messages_sent,
//       total_delivered_count: c.total_delivery_count,
//       delivered_whatsapp_count: c.delivered_whatsapp_count,
//       delivered_sms_count: c.delivered_sms_count
//     }));
//     const worksheet = XLSX.utils.json_to_sheet(filteredData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Campaign_List");
//     XLSX.writeFile(workbook, "CampaignList.xlsx");
//   };

//   const handleDraftTabClick = () => {
//     setActiveTab('Draft');        // switch tab
//     setCurrentPage(1);            // reset pagination
//     setDebouncedSearchTerm('');   // reset search
//     setSearchTerm('');
//     setDateRange({ from: undefined, to: undefined }); // clear date filters
//     setRowsPerPage(10);
//     getDraftList();               // call API
//   };

//   const handleListTabClick = () => {        // switch tab
//     setCurrentPage(1);            // reset pagination
//     setDebouncedSearchTerm('');   // reset search
//     setSearchTerm('');
//     setDateRange({ from: undefined, to: undefined }); // clear date filters
//     setRowsPerPage(10);
//   };

//   if (isLoading) {
//     return (
//       <div className="flex flex-col items-center justify-center h-[500px]">
//         <CircularProgress color="primary" />
//       </div>
//     );
//   }
//   return (
//     <div>
//       {isCampaignListLoading ? (
//         <>
//           <div className="loading-overlay">
//             <CircularProgress color="primary" />
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="fixed flex justify-end items-end right-0 top-[-15px] z-20 p-4 mr-2">
//             {userPermissions.includes("ADV_Campaigns_Create") && (
//               <Button
//                 onClick={handleCreateCampaign}
//                 className="w-36 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px] "
//               >
//                 Create Campaign
//               </Button>
//             )}
//           </div>
//           <div className="mt-4">
//             <div className="flex flex-wrap items-center justify-between gap-4 -mt-6">
//               <div className="flex flex-wrap justify-start w-full md:w-auto gap-10">
//                 <div>
//                   <Input
//                     placeholder={`Search ${activeTab === "Draft" ? "drafts" : "campaigns"} by name...`}
//                     className="w-full md:w-[350px] text-[14px] font-normal text-[#171717] !mt-0"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       const v = e.target.value;
//                       setSearchTerm(v);
//                       if (currentPage !== 1) setCurrentPage(1); // <-- force page 1 on any search
//                     }}
//                   />
//                 </div>
//               </div>

//               <div
//                 className={`flex flex-wrap items-center justify-end w-full md:w-auto ${activeTab === "List" ? "gap-10" : ""
//                   }`}
//               >

//                 {activeTab === 'List' ? (
//                   <>
//                     <div className="flex-shrink-0 -mr-4 ">
//                       <AdvertiserCampaignListDropdown
//                         filterData={filterData}
//                         setFilterData={setFilterData}
//                       />
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="flex-shrink-0 mr-4"></div>
//                   </>
//                 )}

//                 <div className="flex-shrink-0 -mr-4">
//                   <DatePickerWithRange
//                     dateRange={dateRange}
//                     setDateRange={setDateRange}
//                     setInitialCampaign={setInitialCampaign}
//                     setIsClearingDate={setIsClearingDate}
//                   />
//                 </div>

//                 {activeTab === 'List' ? (
//                   <>
//                     <div className="flex-shrink-0">
//                       <Button
//                         variant="outline"
//                         className="w-24 text-[#020617] !mt-0"
//                         onClick={handleExportButtonClick}
//                       >
//                         Export
//                       </Button>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="mr-4"></div>
//                   </>
//                 )}
//               </div>
//             </div>

//             <div className="mt-6">
//               {/* <div className="flex border rounded-t-md overflow-hidden w-fit bg-white shadow-sm">

//               <button
//                 onClick={() => setActiveTab('List')}
//                 className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
//                   activeTab === 'List'
//                     ? 'bg-[#3A85F7] text-white'
//                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                 }`}
//               >
//                 List
//               </button>

//               <button
//                 onClick={handleDraftTabClick}
//                 className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
//                   activeTab === 'Draft'
//                     ? 'bg-[#3A85F7] text-white'
//                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                 }`}
//               >
//                 Drafts
//               </button>
//             </div> */}
//               {/* <AdvertiserCampaignListDropdown
//                 filterData={filterData}
//                 setFilterData={setFilterData}
//               /> */}

//               <div className="flex overflow-hidden w-full justify-start mb-1">
//                 <Tabs defaultValue="List" value={activeTab} onValueChange={setActiveTab} className="flex">
//                   <TabsList>
//                     <TabsTrigger value="List" onClick={handleListTabClick} className="px-8">List</TabsTrigger>
//                     <TabsTrigger value="Draft" onClick={handleDraftTabClick} className="px-8">Drafts</TabsTrigger>
//                   </TabsList>
//                 </Tabs>
//               </div>

//               <div className="rounded-md border p-2">
//                 <div className="max-h-[60vh] overflow-y-auto">
//                   <Table
//                     className="rounded-xl whitespace-nowrap border-gray-200"
//                     style={{ color: "#020202", fontSize: "15px" }}
//                   >
//                     <TableHeader>
//                       <TableRow className="sticky top-0 z-10 bg-white hover:bg-white">
//                         {activeTab === 'Draft' ? (
//                           <>
//                             {/* Draft tab headers - simplified for available data */}
//                             <TableHead className="pl-6 pr-3 py-3 font-medium text-left">
//                               <div className="flex items-center gap-2">
//                                 <span>Campaign name</span>
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium w-[140px] text-left">
//                               <div className="flex items-center gap-2">Channel</div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium text-center">
//                               <div className="flex items-center justify-center gap-2">Total Travellers</div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium text-left">
//                               <div className="flex items-center gap-2">Created Date</div>
//                             </TableHead>
//                             <TableHead className="w-12 py-3"></TableHead>
//                           </>
//                         ) : (
//                           <>
//                             {/* Full List tab headers */}
//                             <TableHead className="pl-6 pr-3 py-3 font-medium">
//                               <div className="flex items-center gap-3">
//                                 <input
//                                   type="checkbox"
//                                   className={`accent-gray-700`}
//                                   checked={isAllSelected}
//                                   onChange={handleSelectAll}
//                                 />
//                                 <span>Campaign name</span>
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByCampaignName")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium w-[140px]">
//                               <div className="flex items-center gap-2">Channel</div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 Campaign Status
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByCampaignStatus")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">Setup Preview</div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 Schedule
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByCampaignDate")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 Total Travellers
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByTotalTravellers")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 People Reached
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByCampaignSent")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 Messages Sent
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByMessagesSent")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="py-3 px-3 font-medium">
//                               <div className="flex items-center gap-2">
//                                 Created Date
//                                 <CaretSortIcon
//                                   onClick={() => sortCampaignList("ByCreatedDate")}
//                                   className="cursor-pointer"
//                                 />
//                               </div>
//                             </TableHead>
//                             <TableHead className="w-12 py-3"></TableHead>
//                           </>
//                         )}
//                       </TableRow>
//                     </TableHeader>

//                     <TableBody>
//                       {activeTab === 'Draft' ? (
//                         <>
//                           {draftLoading || draftList.length === 0 ? (
//                             <TableRow>
//                               <TableCell
//                                 colSpan={5}
//                                 className="text-center py-4 text-gray-500 font-medium"
//                               >
//                                 {draftLoading
//                                   ? "Loading..."
//                                   : searchTerm.trim() !== ""
//                                     ? "No drafts found for the searched item."
//                                     : "No draft campaigns found."}
//                               </TableCell>
//                             </TableRow>
//                           ) : (
//                             draftList.map((draft) => (
//                               <TableRow key={draft.draft_id}>
//                                 <TableCell className="pl-6 pr-3 py-4 text-left align-middle">
//                                   <span className="text-black text-[14px] cursor-pointer font-normal">
//                                     {draft.campaign_name}
//                                   </span>
//                                 </TableCell>
//                                 <TableCell className="py-4 px-3 text-left align-middle w-[140px]">
//                                   {/* {draft.channels?.join(", ") || "-"} */}
//                                   <ChannelCarousel channels={draft.channels || []} />
//                                 </TableCell>
//                                 <TableCell className="py-4 px-3 text-center align-middle">
//                                   {draft.total_travellers || 0}
//                                 </TableCell>
//                                 <TableCell className="py-4 px-3 text-left align-middle">
//                                   {draft.created_time
//                                     ? (() => {
//                                       const iso = /Z|[+\-]\d{2}:\d{2}$/.test(draft.created_time)
//                                         ? draft.created_time
//                                         : `${draft.created_time}Z`;

//                                       const { localDate } = convertUTCToLocal(iso, workspaceTimezone);

//                                       const localTimeWithSeconds = new Intl.DateTimeFormat("en-GB", {
//                                         timeZone: workspaceTimezone || "UTC",
//                                         hour: "2-digit",
//                                         minute: "2-digit",
//                                         second: "2-digit",
//                                         hour12: false,
//                                       }).format(new Date(iso));

//                                       return `${localDate} - ${localTimeWithSeconds}`;
//                                     })()
//                                     : "-"}
//                                 </TableCell>
//                                 <TableCell className="text-right pr-4 py-4 align-middle">
//                                   {/* Draft actions can be added here if needed */}

//                                   {userPermissions.includes("ADV_Campaigns_Edit") && (
//                                     <DropdownMenu>
//                                       <DropdownMenuTrigger asChild>
//                                         <DotsHorizontalIcon

//                                           className="cursor-pointer w-5 h-5"
//                                         />
//                                       </DropdownMenuTrigger>

//                                       <DropdownMenuContent

//                                       >
//                                         <DropdownMenuItem
//                                           className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                           // onClick={() => GetCampaignDraftByWorkspaceId(workspaceId, draft.draft_id)}
//                                           onClick={() => {
//                                             GetCampaignDraftByWorkspaceId(workspaceId, draft.draft_id);

//                                             if (isUpdateMode || isViewMode) {
//                                               resetCampaign();
//                                               resetSMSContent();
//                                               resetWhatsappContent();
//                                               setUpdateCampaignId(null);
//                                               setIsUpdateMode(false);
//                                               setIsViewMode(false);
//                                               setIsDraftMode(false);
//                                             }

//                                             dispatch(setCreateBreadCrumb(true));
//                                             navigate("/navbar/createcampaign", {
//                                               state: { draft_id: draft.draft_id },
//                                             });

//                                           }}

//                                         >
//                                           Create
//                                         </DropdownMenuItem>

//                                         <DropdownMenuItem
//                                           className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                           onClick={() => {
//                                             DeleteCampaignDraftByWorkspaceIdAndDraftId(workspaceId, draft.draft_id);
//                                             getDraftList();
//                                           }}
//                                         >
//                                           Delete
//                                         </DropdownMenuItem>

//                                       </DropdownMenuContent>

//                                     </DropdownMenu>
//                                   )}

//                                 </TableCell>
//                               </TableRow>
//                             ))
//                           )}
//                         </>
//                       ) : (
//                         <>
//                           {campaignList.length > 0 && !campaignLoading ? (
//                             campaignList.map((campaign) => {
//                               const isSelected = checkboxSelectedRows.includes(campaign.campaign_id);

//                                 const canEdit =
//     (campaign.status === "active" && campaign.admin_approval === "rejected") ||
//    ( campaign.status === "sandbox" && campaign.admin_approval === "rejected") ||
//     ( campaign.status === "sandbox" && campaign.status_preview === "Live")

//                               return (
//                                 <TableRow
//                                   key={campaign.campaign_id}
//                                   className={isSelected ? "bg-gray-200" : ""}
//                                 >
//                                   {/* Checkbox + Campaign Name Cell */}
//                                   <TableCell className="pl-6 pr-3 py-4">
//                                     <div className="flex items-center gap-3">
//                                       <input
//                                         type="checkbox"
//                                         className="accent-gray-700"
//                                         checked={isSelected}
//                                         onChange={() => handleCheckboxRowSelect(campaign.campaign_id)}
//                                       />
//                                       <span className="text-black text-[14px] cursor-pointer font-normal">
//                                         {campaign.campaign_name}
//                                       </span>
//                                     </div>
//                                   </TableCell>
//                                   {/* Channel Cell with Carousel */}
//                                   <TableCell className="py-4 px-3 align-middle w-[140px]">
//                                     <ChannelCarousel channels={campaign.channels || []} />
//                                   </TableCell>
//                                   {/* Status */}
//                                   <TableCell className="py-4 px-3 align-middle text-left">
//                                     {campaign.status}
//                                   </TableCell>
//                                   <TableCell className="py-4 px-3 align-middle text-left">
//                                     <StatusPreviewBadge
//                                       value={campaign.status_preview}
//                                       onClick={() => handleStatusNavigate(campaign.campaign_id)}
//                                     />
//                                   </TableCell>
//                                   <TableCell className="py-4 px-3 align-middle">
//                                     <div className="flex items-center gap-2">
//                                       {campaign.start_date ? (
//                                         <>
//                                           {convertUTCToLocal(campaign.start_date, workspaceTimezone).localDate}
//                                           <ArrowRightIcon />
//                                           {campaign.end_date
//                                             ? convertUTCToLocal(campaign.end_date, workspaceTimezone).localDate
//                                             : "-"}
//                                         </>
//                                       ) : (
//                                         "-"
//                                       )}
//                                     </div>
//                                   </TableCell>
//                                   {/* Total Travellers */}
//                                   <TableCell className="py-4 px-3 text-center align-middle">
//                                     {typeof campaign.traveller_count_total !== "undefined"
//                                       ? campaign.traveller_count_total
//                                       : "-"}
//                                   </TableCell>
//                                   {/* Sent */}
//                                   <TableCell className="py-4 px-3 text-left align-middle">
//                                     {typeof campaign.total_sent_count !== "undefined"
//                                       ? campaign.total_sent_count
//                                       : "-"}
//                                   </TableCell>
//                                   <TableCell className="py-4 px-3 text-left align-middle">
//                                     {typeof campaign.total_messages_sent !== "undefined"
//                                       ? campaign.total_messages_sent
//                                       : "-"}
//                                   </TableCell>
//                                   <TableCell className="py-4 px-3 text-left align-middle">
//                                     {campaign.created_date
//                                       ? (() => {
//                                         const iso = /Z|[+\-]\d{2}:\d{2}$/.test(campaign.created_date)
//                                           ? campaign.created_date
//                                           : `${campaign.created_date}Z`;

//                                         const { localDate } = convertUTCToLocal(iso, workspaceTimezone);

//                                         const localTimeWithSeconds = new Intl.DateTimeFormat("en-GB", {
//                                           timeZone: workspaceTimezone || "UTC",
//                                           hour: "2-digit",
//                                           minute: "2-digit",
//                                           second: "2-digit",
//                                           hour12: false,
//                                         }).format(new Date(iso));

//                                         return `${localDate} - ${localTimeWithSeconds}`;
//                                       })()
//                                       : "-"}
//                                   </TableCell>
//                                   {/* Menu */}
//                                   <TableCell className="text-right pr-4 py-4 align-middle">
//                                     {userPermissions.includes("ADV_Campaigns_Edit") && (
//                                       <DropdownMenu >
//                                         <DropdownMenuTrigger asChild>
//                                           <DotsHorizontalIcon
//                                             onClick={() =>
//                                               setOpenMenuRowId(
//                                                 openMenuRowId === campaign.campaign_id
//                                                   ? null
//                                                   : campaign.campaign_id
//                                               )
//                                             }
//                                             className="cursor-pointer w-5 h-5"
//                                           />
//                                         </DropdownMenuTrigger>
//                                         {openMenuRowId === campaign.campaign_id && (
//                                           <DropdownMenuContent
//                                             align="end"
//                                             className="w-40 bg-white shadow-lg rounded p-1 text-sm z-[9999]"
//                                           >

// <DropdownMenuItem
//   onClick={() => handleEdit(campaign.campaign_id)}
//   className={`px-3 py-2 ${
//     canEdit
//       ? "hover:bg-gray-100 cursor-pointer"
//       : "text-gray-400 cursor-not-allowed"
//   }`}
//   disabled={!canEdit}
// >
//   Edit
// </DropdownMenuItem>

//                                             <DropdownMenuItem
//                                               onClick={() => handleView(campaign.campaign_id)}
//                                               className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                             >
//                                               View
//                                             </DropdownMenuItem>
//                                             <DropdownMenuItem
//                                               onClick={() => {
//                                                 setTestModeCampaignId(campaign.campaign_id);
//                                                 setIsTestModeOpen(true);
//                                               }}
//                                               className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                               disabled={campaign.status !== "sandbox" || campaign.status_preview !== "Live"}
//                                             >
//                                               Test Campaign
//                                             </DropdownMenuItem>

//                                             <DropdownMenuItem
//                                               // onClick={() => toggleCampaignStatus(campaign.campaign_id, "active")}
//                                               onClick={async () => {
//   const success = await toggleCampaignStatus(campaign.campaign_id, "active");

//   if (success) {
//     await axios.post(`${apiUrlAdminAcc}/InsertAuditHistory`, {
//       UserAccountId: accountId,
//       CampaignId: campaign.campaign_id,
//       AdvertiserWorkspaceId: workspaceId,
//       Action: 'Campaign Promoted To Live',
//       ActionPage: 'Advertiser Campaign List',
//       Status: 'active',
//       BeforeData: null,
//       AfterData: null,
//       Comments: 'Campaign promoted to live',
//       ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
//     });
//   }
// }}
//                                               className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                               // disabled={campaign.status !== "sandbox"}
//                                               disabled={campaign.status !== "sandbox" || campaign.status_preview !== "Live"}
//                                             >
//                                               Move to Live
//                                             </DropdownMenuItem>

//                                             <DropdownMenuItem
//                                               onClick={() => handleInternalOpenDialog(campaign.campaign_id)}
//                                               disabled={campaign.admin_approval === "approved"}
//                                               className="px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed"
//                                             >
//                                               Delete
//                                             </DropdownMenuItem>
//                                             {campaign.status === "active" && (
//                                               <DropdownMenuItem
//                                                 onClick={() =>
//                                                   toggleCampaignStatus(campaign.campaign_id, "paused")
//                                                 }
//                                                 className="px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed"
//                                               >
//                                                 Pause
//                                               </DropdownMenuItem>
//                                             )}

//                                             {campaign.status === "paused" && (
//                                               <DropdownMenuItem
//                                                 onClick={() =>
//                                                   toggleCampaignStatus(campaign.campaign_id, "active")
//                                                 }
//                                                 className="px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed"
//                                               >
//                                                 Resume
//                                               </DropdownMenuItem>
//                                             )}
//                                             <DropdownMenuItem
//                                               onClick={() => {
//                                                 setOpenMenuRowId(null);
//                                                 setDetailedSummaryModal({
//                                                   isOpen: true,
//                                                   campaign: campaign,
//                                                 });
//                                               }}
//                                               className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                                             >
//                                               View Detailed Summary
//                                             </DropdownMenuItem>
//                                           </DropdownMenuContent>
//                                         )}
//                                       </DropdownMenu>
//                                     )}
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })
//                           ) : (
//                             <TableRow>
//                               <TableCell
//                                 colSpan={10}
//                                 className="text-center py-4 text-gray-500 font-medium"
//                               >
//                                 {campaignLoading
//                                   ? "Loading..."
//                                   : searchTerm.trim() !== ""
//                                     ? "No campaigns found for the searched item."
//                                     : "No campaigns found."}
//                               </TableCell>
//                             </TableRow>
//                           )}
//                         </>
//                       )}
//                     </TableBody>
//                   </Table>
//                 </div>
//               </div>

//               {/* Pagination controls */}
//               <div className="flex justify-between items-center mt-4">
//                 <div className="flex items-center space-x-2 text-gray-500 text-sm ">
//                   {/* <span>{`${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
//                     currentPage * rowsPerPage,
//                     totalCount
//                   )} of ${totalCount} row(s) selected`}</span> */}
//                   <span>{
//                     (activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                       ? "0 of 0 row(s) selected"
//                       : `${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
//                         currentPage * rowsPerPage,
//                         activeTab === "Draft" ? totalDraftCount : totalCount
//                       )} of ${activeTab === "Draft" ? totalDraftCount : totalCount} row(s) selected`
//                   }</span>

//                 </div>
//                 <div className="flex items-center space-x-4 font-medium text-sm">
//                   <span className="text-[#020617] font-medium text-[14px]">Rows per page</span>
//                   <div className="relative inline-block ml-2">
//                     <select
//                       disabled={campaignList.length === 0}
//                       className={`cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 ${campaignList.length === 0 ? "cursor-not-allowed bg-gray-100" : ""}`}
//                       style={{
//                         width: "60px",
//                         height: "30px",
//                         textAlign: "left",
//                         fontSize: "12px",
//                         fontWeight: "400",
//                         borderColor: "#E5E7EB",
//                         boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
//                       }}
//                       value={rowsPerPage}
//                       onChange={(e) => {
//                         setRowsPerPage(Number(e.target.value));
//                         setCurrentPage(1);
//                       }}
//                     >
//                       {[5, 10, 20].map((num) => (
//                         <option key={num} value={num}>
//                           {num}
//                         </option>
//                       ))}
//                     </select>
//                     <CaretSortIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
//                   </div>
//                   <div className="ml-4 mr-4">
//                     <span className="text-[#020617] text-[14px] font-medium">
//                       {(activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                         ? "Page 1 of 1"
//                         : `Page ${currentPage} of ${totalPages}`}
//                     </span>
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <button
//                       disabled={currentPage === 1 || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0}
//                       className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1 || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                         ? "cursor-not-allowed bg-gray-100"
//                         : "hover:bg-gray-200"
//                         }`}
//                       onClick={() => setCurrentPage(1)}
//                     >
//                       «
//                     </button>
//                     <button
//                       disabled={currentPage === 1 || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0}
//                       className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === 1 || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                         ? "cursor-not-allowed bg-gray-100"
//                         : "hover:bg-gray-200"
//                         }`}
//                       onClick={() => setCurrentPage(currentPage - 1)}
//                     >
//                       ‹
//                     </button>
//                     <button
//                       disabled={currentPage === totalPages || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0}
//                       className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                         ? "cursor-not-allowed bg-gray-100"
//                         : "hover:bg-gray-200"
//                         }`}
//                       onClick={() => setCurrentPage(currentPage + 1)}
//                     >
//                       ›
//                     </button>
//                     <button
//                       disabled={currentPage === totalPages || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0}
//                       className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${currentPage === totalPages || (activeTab === "Draft" ? totalDraftCount : totalCount) === 0
//                         ? "cursor-not-allowed bg-gray-100"
//                         : "hover:bg-gray-200"
//                         }`}
//                       onClick={() => setCurrentPage(totalPages)}
//                     >
//                       »
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Delete Dialog */}
//           <Dialog open={isInternalDialogOpen} onClose={() => setInternalDialogOpen(false)}>
//             <DialogContent>
//               <DialogContentText>Are you sure you want to delete this campaign?</DialogContentText>
//             </DialogContent>
//             <DialogActions>
//               <Button
//                 variant="outline"
//                 className="w-24"
//                 onClick={() => setInternalDialogOpen(false)}
//               >
//                 Cancel
//               </Button>
//               <Button className="w-24" onClick={confirmDelete} autoFocus disabled={isApiExecuting}>
//                 {isApiExecuting ? "Deleting" : "Delete"}
//               </Button>
//             </DialogActions>
//           </Dialog>

//           {/* Detailed Summary Dialog */}
//           <Dialog
//             open={detailedSummaryModal.isOpen}
//             onClose={() => setDetailedSummaryModal({ isOpen: false, campaign: null })}
//             aria-labelledby="detailed-summary-title"
//             maxWidth="xs"
//             fullWidth={false}
//             PaperProps={{
//               sx: {
//                 borderRadius: "10px",
//                 p: 1,
//                 width: 420,
//                 maxWidth: "calc(100% - 32px)",
//               },
//             }}
//           >
//             <DialogTitle id="detailed-summary-title" sx={{ pb: "12px" }}>
//               <div className="text-left text-base font-semibold text-gray-900">
//                 Campaign Name :{" "}
//                 <span className="text-[#3A85F7]">{detailedSummaryModal.campaign?.campaign_name}</span>
//               </div>
//             </DialogTitle>

//             <DialogContent sx={{ pt: 0 }}>
//               <div className="space-y-4">
//                 {detailedSummaryModal.campaign?.channels?.includes("WhatsApp") && (
//                   <div
//                     className="flex justify-between items-center p-3 rounded-lg"
//                     style={{
//                       backgroundColor: "rgba(71, 158, 152, 0.10)",
//                       border: `1px solid #479E98`,
//                     }}
//                   >
//                     <div className="flex items-center gap-2">
//                       <div className="w-3 h-3 rounded-full" style={{ backgroundColor: "#479E98" }} />
//                       <span className="text-gray-700 font-medium text-sm">WhatsApp Delivered</span>
//                     </div>
//                     <span className="font-semibold text-sm" style={{ color: "#479E98" }}>
//                       {detailedSummaryModal.campaign?.delivered_whatsapp_count || 0}
//                     </span>
//                   </div>
//                 )}

//                 {detailedSummaryModal.campaign?.channels?.includes("SMS") && (
//                   <div
//                     className="flex justify-between items-center p-3 rounded-lg"
//                     style={{
//                       backgroundColor: "rgba(223, 165, 72, 0.12)",
//                       border: `1px solid #DFA548`,
//                     }}
//                   >
//                     <div className="flex items-center gap-2">
//                       <div className="w-3 h-3 rounded-full" style={{ backgroundColor: "#DFA548" }} />
//                       <span className="text-gray-700 font-medium text-sm">SMS Delivered</span>
//                     </div>
//                     <span className="font-semibold text-sm" style={{ color: "#DFA548" }}>
//                       {detailedSummaryModal.campaign?.delivered_sms_count || 0}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </DialogContent>

//             <DialogActions sx={{ pt: "8px", justifyContent: "center" }}>
//               <Button
//                 variant="outline"
//                 onClick={() => setDetailedSummaryModal({ isOpen: false, campaign: null })}
//                 className="w-20 cursor-pointer"
//               >
//                 Close
//               </Button>
//             </DialogActions>
//           </Dialog>
//           <TestModeDialog
//             open={isTestModeOpen}
//             onOpenChange={setIsTestModeOpen}
//             campaignId={testModeCampaignId}
//           />
//         </>
//       )}
//     </div>
//   );

// };

// export default CampaignList;

import React, { useState, useEffect, useRef } from 'react';
import { Button } from '../../Components/ui/button';
import { Input } from '../../Components/ui/input';
import { Badge } from '../../Components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import {
  CalendarIcon,
  CaretSortIcon,
  ArrowRightIcon,
  DotsHorizontalIcon,
} from '@radix-ui/react-icons';
import { format } from 'date-fns';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../Components/ui/popover';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../Components/ui/table';
import { Calendar } from '../../Components/ui/calendar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from "react-toastify";
import { Toaster } from '../../Components/ui/toaster';
import { toast, useToast } from '../../Components/ui/use-toast';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import { RootState } from '../../State/store';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../Components/ui/dropdown-menu';
import { DateRange } from 'react-day-picker';
import { setCreateBreadCrumb } from '../../State/slices/AdvertiserAccountSlice';
import {
  CampaignProvider,
  useCampaignContext,
} from './CreateCampaign/CampaignContext';
import { convertUTCToLocal } from '../../../src/utils/convertUTCToLocal';
import { RowData } from './CreateCampaign/CampaignContext';
import { setSelectedFromCountryISOs } from '../../State/slices/AdvertiserAccountSlice';
import { Tabs, TabsList, TabsTrigger } from '../../../src/Components/ui/tabs';
import AdvertiserCampaignListDropdown from '../../Components/Filter/AdvertiserCampaignListDropdown';
import TestModeDialog from './TestMode';

interface Campaign {
  user_account_id: number;
  campaign_id: number;
  // advertiser_workspace_id: number;
  campaign_name: string;
  advertiser_workspace_id: number;
  admin_approval: string;
  status: string;
  start_date: string;
  end_date: string;
  channels: (string | null)[];
  traveller_count_total: number;
  total_sent_count: number;
  total_messages_sent: number;
  status_preview?: string;
  total_delivery_count: number;
  delivered_whatsapp_count: number;
  delivered_sms_count: number;
  created_date: string;
  sent_test_mode_count: number;
  delivered_test_mode_count: number;
}

interface Country {
  country_name: string;
  country_code: string;
  country_iso: string;
}

interface Draft {
  draft_id: number;
  workspace_id: number;
  campaign_name: string;
  channels: (string | null)[];
  start_date: string;
  end_date: string;
  total_travellers: number;
  created_time: string;
}

// Channel carousel
const ChannelCarousel: React.FC<{ channels?: (string | null)[] }> = ({
  channels = [],
}) => {
  const filteredChannels = Array.isArray(channels)
    ? (channels.filter(Boolean) as string[])
    : [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSliding, setIsSliding] = useState(true);
  const badgeRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [offsets, setOffsets] = useState<number[]>([]);

  useEffect(() => {
    if (filteredChannels.length > 1) {
      const t = setTimeout(() => {
        const allOffsets: number[] = [];
        let sum = 0;
        for (let i = 0; i < filteredChannels.length; i++) {
          allOffsets.push(sum);
          const w = badgeRefs.current[i]?.offsetWidth ?? 0;
          sum += w + 2;
        }
        setOffsets(allOffsets);
      }, 0);
      return () => clearTimeout(t);
    }
  }, [filteredChannels.length, filteredChannels.join('|')]); // ← safe

  useEffect(() => {
    if (filteredChannels.length <= 1) return;
    let timeout: ReturnType<typeof setTimeout>;
    if (isSliding) {
      timeout = setTimeout(() => setIsSliding(false), 4000);
    } else {
      timeout = setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % filteredChannels.length);
        setIsSliding(true);
      }, 1000);
    }
    return () => clearTimeout(timeout);
  }, [isSliding, filteredChannels.length]);

  if (filteredChannels.length === 0)
    return <span className='text-gray-400'>-</span>;

  if (filteredChannels.length === 1) {
    const channel = filteredChannels[0];
    return (
      <div className='flex items-center h-7'>
        <Badge
          className={
            channel === 'WhatsApp'
              ? ''
              : channel === 'SMS'
                ? ''
                : channel === 'Push Notification' || channel === 'Push'
                  ? ''
                  : channel === 'Email'
                    ? 'bg-blue-400'
                    : 'bg-gray-400'
          }
          style={
            channel === 'WhatsApp'
              ? { backgroundColor: '#479E98', color: '#fff' }
              : channel === 'SMS'
                ? { backgroundColor: '#DFA548', color: '#fff' }
                : channel === 'Push Notification' || channel === 'Push'
                  ? { backgroundColor: '#B87867', color: '#fff' }
                  : channel === 'RCS' || channel === 'RCS messages'
                    ? { backgroundColor: '#61177E', color: '#fff' }
                    : {}
          }
        >
          {channel}
        </Badge>
      </div>
    );
  }

  return (
    <div className='relative h-7 w-[120px] overflow-hidden'>
      <div
        className='flex items-center'
        style={{
          gap: '2px',
          transform: `translateX(-${offsets[currentIndex] ?? 0}px)`,
          transition: isSliding
            ? 'transform 4s cubic-bezier(0.5,0,0.5,1)'
            : 'none',
        }}
      >
        {filteredChannels.map((channel, idx) => (
          <div
            key={`${channel}-${idx}`}
            ref={(el) => (badgeRefs.current[idx] = el)}
            className='flex items-center'
            style={{ margin: 0, padding: 0 }}
          >
            <Badge
              className={
                channel === 'WhatsApp'
                  ? ''
                  : channel === 'SMS'
                    ? ''
                    : channel === 'Push Notification' || channel === 'Push'
                      ? ''
                      : channel === 'Email'
                        ? 'bg-blue-400'
                        : 'bg-gray-400'
              }
              style={
                channel === 'WhatsApp'
                  ? { backgroundColor: '#479E98', color: '#fff' }
                  : channel === 'SMS'
                    ? { backgroundColor: '#DFA548', color: '#fff' }
                    : channel === 'Push Notification' || channel === 'Push'
                      ? { backgroundColor: '#B87867', color: '#fff' }
                      : channel === 'RCS' || channel === 'RCS messages'
                        ? { backgroundColor: '#61177E', color: '#fff' }
                        : {}
              }
            >
              {channel}
            </Badge>
          </div>
        ))}
      </div>
    </div>
  );
};

const StatusPreviewBadge: React.FC<{
  value?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({ value, onClick }) => {
  const raw = (value ?? '').trim();
  const hasWarning = /with warning symbol/i.test(raw);
  const base = raw.replace(/with warning symbol/gi, '').trim();

  // normalize variants
  const norm = base.toLowerCase().replace(/\s+/g, ' ');

  type Key =
    | 'live'
    | 'partially live'
    | 'completed'
    | 'in review'
    | 'rejected'
    | 'pending';
  const key: Key =
    norm === 'live'
      ? 'live'
      : norm === 'partially live' || norm === 'partialy live'
        ? 'partially live'
        : norm === 'completed'
          ? 'completed'
          : norm === 'in review' || norm === 'inreview'
            ? 'in review'
            : norm === 'rejected'
              ? 'rejected'
              : 'pending';

  // fixed colors (no hover color change)
  let colorClasses = '';
  switch (key) {
    case 'live':
      colorClasses =
        '!bg-green-700 text-white hover:!bg-green-700 hover:text-white';
      break;
    case 'partially live':
      colorClasses =
        '!bg-green-300 text-gray-900 hover:!bg-green-300 hover:text-gray-900';
      break;
    case 'completed':
      colorClasses =
        '!bg-blue-600 text-white hover:!bg-blue-600 hover:text-white';
      break;
    case 'in review':
      colorClasses =
        '!bg-yellow-400 text-gray-900 hover:!bg-yellow-400 hover:text-gray-900';
      break;
    case 'rejected':
      colorClasses =
        '!bg-red-600 text-white hover:!bg-red-600 hover:text-white';
      break;
    case 'pending':
    default:
      colorClasses =
        '!bg-gray-400 text-white hover:!bg-gray-400 hover:text-white';
      break;
  }

  const label = key.replace(/\b\w/g, (c) => c.toUpperCase());

  // subtle hover/focus effect (no color change)
  const hoverFx =
    'transform-gpu transition-transform duration-200 ease-out ' +
    'hover:scale-[1.08] focus-visible:scale-[1.05] active:scale-100 ' +
    'hover:shadow-lg';

  return (
    <button
      type='button'
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className='inline-flex items-center gap-1 p-0 m-0 bg-transparent hover:bg-transparent focus:outline-none focus:ring-0 cursor-pointer'
      aria-label={`Open campaign status (${label}${hasWarning ? ' – warning' : ''})`}
      title='View status details'
    >
      <Badge
        className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium select-none ${colorClasses} ${hoverFx}`}
      >
        <span>{label}</span>
      </Badge>
      {hasWarning && (
        <AlertTriangle
          size={20}
          className='ml-1 text-red-600'
          aria-hidden='true'
        />
      )}
    </button>
  );
};

const DatePickerWithRange: React.FC<{
  dateRange: DateRange | undefined;
  setDateRange: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
  setInitialCampaign: React.Dispatch<React.SetStateAction<boolean>>;
  setIsClearingDate: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ dateRange, setDateRange, setInitialCampaign, setIsClearingDate }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button
        variant='outline'
        className='min-w-[150px] w-auto justify-start text-left font-normal mt-0'
      >
        <CalendarIcon className='mr-2 h-4 w-4' />
        {dateRange?.from ? (
          dateRange.to ? (
            <>
              {format(dateRange.from, 'LLL dd, y')} -{' '}
              {format(dateRange.to, 'LLL dd, y')}
            </>
          ) : (
            format(dateRange.from, 'LLL dd, y')
          )
        ) : (
          <span>Pick a date</span>
        )}
      </Button>
    </PopoverTrigger>
    <PopoverContent className='w-auto p-0' align='start'>
      <Calendar
        initialFocus
        mode='range'
        defaultMonth={dateRange?.from ?? new Date()}
        selected={dateRange}
        onSelect={(range: DateRange | undefined) => {
          if (
            !range?.from &&
            !range?.to &&
            (dateRange?.from || dateRange?.to)
          ) {
            setIsClearingDate(true);
          }
          setDateRange(range);
          if ((range?.from && range?.to) || (!range?.from && !range?.to)) {
            setInitialCampaign(false);
          }
        }}
        numberOfMonths={1}
      />
    </PopoverContent>
  </Popover>
);

const CampaignList: React.FC = () => {
  // Redux/selectors
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  ); // HARDCODED for demo
  const userPermissions = useSelector(
    (state: RootState) => state.advertiserAccount.permissions,
  );
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );
  const apiUrlAdminAcc = useSelector(
    (state: RootState) => state.authentication.adminUrl,
  );

  // State
  const [campaignList, setCampaignList] = useState<Campaign[]>([]);

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [checkboxSelectedRows, setCheckboxSelectedRows] = useState<number[]>(
    [],
  );
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [campaignLoading, setCampaignLoading] = useState(true);
  const [isInternalDialogOpen, setInternalDialogOpen] = useState(false);
  const [isApiExecuting, setIsApiExecuting] = useState(false);
  const [campaignToDelete, setCampaignToDelete] = useState<number | null>(null);
  const [campaignNameToDelete, setCampaignNameToDelete] = useState<
    string | null
  >(null);
  const [dateRange, setDateRange] = useState<DateRange | undefined>();
  const [initialcampaign, setInitialCampaign] = useState(true);
  const [isClearingDate, setIsClearingDate] = useState(false);

  const [detailedSummaryModal, setDetailedSummaryModal] = useState<{
    isOpen: boolean;
    campaign: Campaign | null;
  }>({ isOpen: false, campaign: null });

  const [sortField, setSortField] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const workspaceTimezone = useSelector(
    (state: RootState) => state.authentication.workspaceTimezone,
  );

  const [walletstatus, setWalletStatus] = useState<boolean>();

  const [isCampaignListLoading, setIsCampaignListLoading] =
    useState<boolean>(false);

  // Draft State
  const [draftList, setDraftList] = useState<Draft[]>([]);
  const [totalDraftCount, setTotalDraftCount] = useState(0);
  const [draftLoading, setDraftLoading] = useState(false);

  const [isDraftEnabled, setIsDraftEnabled] = useState(false);
  const toggleDraft = () => {
    setIsDraftEnabled(!isDraftEnabled);
  };

  const [isExporting, setIsExporting] = useState(false);

  const [activeTab, setActiveTab] = useState('List');
  const [isTestModeOpen, setIsTestModeOpen] = useState(false);
  const [testModeCampaignId, setTestModeCampaignId] = useState<number | null>(
    null,
  );

  const workspaceName = useSelector(
    (state: RootState) => state.authentication.workspaceName,
  );

  const Email = useSelector(
    (state: RootState) => state.authentication.userEmail,
  );

  // const handleTabChange = (tab: string) => {
  //   setActiveTab(tab);
  // };

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.body.style.pointerEvents = "";
  //   }, 500);
  //   setActiveTab("basic");
  // }, [activeTab]);

  const {
    campaignName,
    fromCountries,
    toCountry,
    campaignStartDate,
    campaignEndDate,
    startTime,
    endTime,
    campaignDesc,
    allocationType,
    setAllocationType,
    isDuplicatePrevented,
    whatsappData,
    smsData,
    whatsappContent,
    smsContent,
    isPremiumOnly,
    selectedToCountryISO,
    fromCountryISOs,
    setCampaignNameError,
    setFromCountryError,
    setToCountryError,
    setContentError,
    setStartDateError,
    setEndDateError,
    setEndTimeError,
    setStartTimeError,
    setIsSubmitAttempted,
    selectedToCountryCode,
    selectedFromCountryCodes,
    selectedTimeZone,
    setWhatsappContent,
    setSmsContent,
    setSelectedTimeZone,
    timezoneOptions,
    setBody,
    setLanguage,
    setMediaBase64,
    setHeaderType,
    setSelectedOption,
    setTextInput,
    setBodyText,
    setFooterText,
    setRows,
    setFromCountryISOsFromAPI,
    setToCountryISOFromAPI,
    setUpdateModeTravellerCount,
    setFileType,
    setFileLength,
    setFileName,
    setPreviewImage,
    setSelectedFile,
    countValidationAgainstEachCountry,
    hasInsufficientMessages,
    setPartsCount,
    setShowWarning,
    setMediaConfig,
    setLoading,
    setUpdateCampaignId,
    resetCampaign,
    resetSMSContent,
    resetWhatsappContent,
    setIsUpdateMode,
    isUpdateMode,
    setCampaignName,
    setEndTime,
    setStartTime,
    setCampaignEndDate,
    setCampaignStartDate,
    setIsPremiumOnly,
    setIsDuplicatePrevented,
    setFromCountryCodeMap,
    setFromCountryISOs,
    setFromCountryOptions,
    setCountries,
    setSelectedFromCountryCodes,
    setFromCountries,
    FromCountryOptions,
    setToCountry,
    setSelectedToCountryCode,
    setSelectedToCountryISO,
    setIsDraftMode,
    setDraftModeTravellerCount,
    isViewMode,
    setIsViewMode,
    setIsTestMode,
  } = useCampaignContext();

  const selectedFromCountryISOs = useSelector(
    (state: RootState) => state.advertiserAccount.selectedFromCountryISOs,
  );

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );
  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  const toast = useToast();

  const [filterData, setFilterData] = useState<{
    filter: string;
    value: string;
  }>({
    filter: 'None',
    value: '',
  });

  const getDraftList = async () => {
    if (!workspaceId || !apiUrlAdvAcc) return;
    setDraftLoading(true); // separate loading state for drafts
    try {
      const params: any = {
        workspaceId,
        page: currentPage, // reused existing pagination state
        rowsPerPage, // reused existing pagination state
        searchTerm: debouncedSearchTerm || undefined, // reused existing debounced search
      };

      // Optional: include dates if desired (shared dateRange state)
      if (dateRange?.from && dateRange?.to) {
        params.startDate = format(dateRange.from, 'yyyy-MM-dd');
        params.endDate = format(dateRange.to, 'yyyy-MM-dd');
      }

      const response = await axios.get(
        `${apiUrlAdvAcc}/GetAllCampaignDraftsByWorkspaceId/${workspaceId}`,
        { params },
      );
      if (response.data.status === 'Success') {
        setDraftList(response.data.draftList || []);
        setTotalDraftCount(response.data.distinctDraftCount || 0);
      } else {
        setDraftList([]);
        setTotalDraftCount(0);
      }
    } catch {
      setDraftList([]);
      setTotalDraftCount(0);
    } finally {
      setDraftLoading(false);
    }
  };

  // Fetch
  const getCampaignList = async () => {
    if (!workspaceId || !apiUrlAdvAcc) return;
    setCampaignLoading(true);
    try {
      const params: any = {
        workspaceId,
        page: currentPage,
        rowsPerPage,
        searchTerm: debouncedSearchTerm || undefined,
        filter: filterData.filter !== 'None' ? filterData.filter : undefined,
        subFilter: filterData.filter !== 'None' ? filterData.value : undefined,
      };
      if (dateRange?.from && dateRange?.to) {
        params.startDate = format(dateRange.from, 'yyyy-MM-dd');
        params.endDate = format(dateRange.to, 'yyyy-MM-dd');
      }
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetCampaignListbyWorkspaceId/${workspaceId}`,
        { params },
      );
      if (response.data.status === 'Success') {
        setCampaignList(response.data.campaignList || []);
        setTotalCount(response.data.distinctCampaignCount || 0);
      } else {
        setCampaignList([]);
        setTotalCount(0);
      }
    } catch {
      setCampaignList([]);
      setTotalCount(0);
    } finally {
      setCampaignLoading(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (searchTerm !== debouncedSearchTerm) return;
    getCampaignList(); /* eslint-disable-next-line */
    getDraftList();
  }, [
    workspaceId,
    currentPage,
    rowsPerPage,
    debouncedSearchTerm,
    dateRange,
    filterData,
  ]);

  useEffect(() => {
    const d = setTimeout(() => setDebouncedSearchTerm(searchTerm), 500);
    return () => clearTimeout(d);
  }, [searchTerm]);

  // Checkbox/Select
  const handleCheckboxRowSelect = (id: number) => {
    setCheckboxSelectedRows((prev) => {
      const newSelectedRows = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      setIsAllSelected(newSelectedRows.length === campaignList.length);
      return newSelectedRows;
    });
  };
  const handleSelectAll = () => {
    if (isAllSelected) setCheckboxSelectedRows([]);
    else setCheckboxSelectedRows(campaignList.map((c) => c.campaign_id));
    setIsAllSelected(!isAllSelected);
  };

  const formatCreated = (v?: string) =>
    v ? v.replace('T', ' ').split('.')[0] : '-';

  const toMs = (v: any) =>
    v ? new Date(String(v).replace(' ', 'T')).getTime() : 0;

  // Sorting
  const sortCampaignList = (field: string) => {
    let type: 'string' | 'number' | 'date' = 'string';
    switch (field) {
      case 'ByCampaignName':
        type = 'string';
        break;
      case 'ByCampaignStatus':
        type = 'string';
        break;
      case 'ByCampaignDate':
        type = 'date';
        break;
      case 'ByTotalTravellers':
        type = 'number';
        break;
      case 'ByCampaignSent':
        type = 'number';
        break;
      case 'ByMessagesSent':
        type = 'number';
        break;
      case 'ByCreatedDate': // 🔹 NEW
        type = 'date';
        break;
      default:
        break;
    }

    let direction: 'asc' | 'desc' = 'asc';
    if (sortField === field)
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortDirection(direction);

    const sorted = [...campaignList].sort((a, b) => {
      let aValue: any, bValue: any;
      switch (field) {
        case 'ByCampaignName':
          aValue = a.campaign_name || '';
          bValue = b.campaign_name || '';
          break;
        case 'ByCampaignStatus':
          aValue = a.status || '';
          bValue = b.status || '';
          break;
        case 'ByCampaignDate':
          aValue = a.start_date;
          bValue = b.start_date;
          break;
        case 'ByTotalTravellers':
          aValue = a.traveller_count_total || 0;
          bValue = b.traveller_count_total || 0;
          break;
        case 'ByCampaignSent':
          aValue = a.total_sent_count || 0;
          bValue = b.total_sent_count || 0;
          break;
        case 'ByMessagesSent':
          aValue = a.total_messages_sent || 0;
          bValue = b.total_messages_sent || 0;
          break;
        case 'ByCreatedDate': // 🔹 NEW
          aValue = a.created_date || '';
          bValue = b.created_date || '';
          break;
        default:
          return 0;
      }

      if (type === 'number') {
        return direction === 'asc' ? aValue - bValue : bValue - aValue;
      } else if (type === 'date') {
        const aMs = toMs(aValue);
        const bMs = toMs(bValue);
        return direction === 'asc' ? aMs - bMs : bMs - aMs;
      } else {
        return direction === 'asc'
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    });

    setCampaignList(sorted);
  };

  const getWalletStatusByWorkspaceId = async (): Promise<boolean | null> => {
    try {
      setIsCampaignListLoading(true);
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetWorkspaceWalletStatusByWorkspaceId`,
        {
          params: { workspaceInfoId: workspaceId },
        },
      );

      if (response.data?.status === 'Success') {
        const walletStatus = response.data.wallet_status;
        return walletStatus; // ✅ this is crucial
      } else {
        setIsCampaignListLoading(false);
        return null;
      }
    } catch (error) {
      setIsCampaignListLoading(false);
      console.error('Error retrieving wallet status:', error);
      return null;
    }
  };

  const GetFromCountries = async () => {
    try {
      setIsCampaignListLoading(true);
      const response = await axios.get(`${apiUrlAdvAcc}/GetFromCountries`);
      if (
        response.data?.status === 'Success' &&
        Array.isArray(response.data.fromCountries)
      ) {
        const countries = response.data.fromCountries as Country[];
        setCountries(countries);
        const dropdownOptions = countries.map((c) => ({
          label: c.country_name,
          value: c.country_name,
        }));

        const isoMap = countries.reduce<{ [name: string]: string }>(
          (acc, c) => {
            acc[c.country_name] = c.country_iso;
            return acc;
          },
          {},
        );

        const codeMap = countries.reduce<{ [iso: string]: string }>(
          (acc, c) => {
            acc[c.country_iso] = c.country_code;
            return acc;
          },
          {},
        );

        setFromCountryOptions(dropdownOptions);
        setFromCountryISOs(isoMap);
        setFromCountryCodeMap(codeMap);
      }
    } catch (err) {
      setIsCampaignListLoading(false);
      console.log('Error :', err);
    } finally {
      // setLoading(false); // Always runs
    }
  };

  // Update your GetCampaignDraftByWorkspaceId function to include template loading
  const GetCampaignDraftByWorkspaceId = async (
    workspaceId: number,
    draftId: number,
  ) => {
    try {
      setIsCampaignListLoading(true);
      // const response = await axios.get(
      //   `${apiUrlAdvAcc}/GetCampaignDraftByWorkspaceId?workspaceId=${workspaceId}`
      // );
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetCampaignDraftByWorkspaceId?workspaceId=${workspaceId}&draftId=${draftId}`,
      );

      if (
        response.data?.status !== 'Success' ||
        !response.data?.draftData ||
        response.data.draftData === '{}'
      ) {
        console.warn('No campaign draft found for workspaceId:', workspaceId);
        return null;
      }

      const draft = JSON.parse(response.data.draftData);
      const details = draft?.campaigndetails ?? {};
      const templates = draft?.templatedetails ?? {}; // NEW: Extract template details

      if (
        (details.total_traveller_count?.sms_count?.length ?? 0) === 0 &&
        (details.total_traveller_count?.whatsapp_count?.length ?? 0) === 0
      ) {
        console.warn('No campaign draft found for workspaceId:', workspaceId);
        return null;
      }

      // ============= EXISTING CAMPAIGN DETAILS EXTRACTION =============
      setCampaignName(details.campaign_name ?? '');
      setCampaignStartDate(details.campaign_start_date ?? '');
      setCampaignEndDate(details.campaign_end_date ?? '');
      setStartTime(details.start_time ?? '');
      setEndTime(details.end_time ?? '');
      setAllocationType(details.allocation_type ?? 'Lifetime Allocation');
      //setRoamingDays(String(draft?.campaigndetails?.roaming_days ?? 1));
      setIsDuplicatePrevented(details.is_duplicate_prevented ?? true);
      setIsPremiumOnly(details.is_premium_only ?? false);

      // ISOs, Dial codes, Names
      // setSelectedFromCountryISOs(draft.campaigndetails.selectedFromCountryISOs);

      dispatch(
        setSelectedFromCountryISOs(
          draft.campaigndetails.selectedFromCountryISOs,
        ),
      );
      setSelectedFromCountryCodes(draft.campaigndetails.from_countries);
      setFromCountries(draft.campaigndetails.fromCountries);
      setToCountry(draft.campaigndetails.toCountry);
      setSelectedToCountryISO(draft.campaigndetails.selectedToCountryISO);
      setSelectedToCountryCode(draft.campaigndetails.to_country);
      setIsTestMode(draft.campaigndetails.is_test_mode ?? false);

      // Traveller count
      if (draft.campaigndetails.total_traveller_count) {
        setDraftModeTravellerCount(draft.campaigndetails.total_traveller_count);
        setIsDraftMode(true);
      }

      // ============= NEW: TEMPLATE LOADING SECTION =============

      // ✅ Helper function to convert base64 to real File object (same as update mode)
      const base64ToFile = (
        base64String: string,
        fileName: string,
        fileType: string,
      ): File => {
        const base64Data = base64String.includes(',')
          ? base64String.split(',')[1]
          : base64String;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        return new File([blob], fileName, { type: fileType });
      };

      // 🔹 Load WhatsApp Template from Draft
      if (templates.whatsappContent?.template) {
        const whatsappTemplate = templates.whatsappContent.template;
        const content = whatsappTemplate.template_content;

        console.log('📱 WhatsApp Template Found in Draft:', {
          whatsappTemplate,
          content,
        });

        // ✅ Set complete WhatsApp content to context
        setWhatsappContent(templates.whatsappContent);

        // ✅ Set media config states
        const mediaConfig = whatsappTemplate.media_config || {};
        setMediaBase64(mediaConfig.binary_data || '');
        setFileName(mediaConfig.file_name || '');
        setFileLength(mediaConfig.file_length || '');
        setFileType(mediaConfig.file_type || '');

        // ✅ Set combined media config state
        setMediaConfig({
          file_name: mediaConfig.file_name || '',
          file_type: mediaConfig.file_type || '',
          binary_data: mediaConfig.binary_data || '',
          file_length: mediaConfig.file_length || '',
        });

        // ✅ Set language
        setLanguage(content.language || '');

        // 🔹 Parse components from string
        let components = [];
        try {
          components = JSON.parse(content.components || '[]');
        } catch (e) {
          console.warn('Failed to parse WhatsApp components:', e);
          components = [];
        }

        // 🔸 HEADER Component
        const headerComponent = components.find(
          (comp: any) => comp.type === 'HEADER',
        );
        if (headerComponent && headerComponent.format) {
          const apiFormat = headerComponent.format;

          switch (apiFormat.toUpperCase()) {
            case 'TEXT':
              setHeaderType('text');
              setSelectedOption('text');
              setTextInput(headerComponent.text || '');
              break;

            case 'IMAGE':
              setHeaderType('image');
              setSelectedOption('image');
              if (
                mediaConfig.binary_data &&
                mediaConfig.binary_data.trim() !== ''
              ) {
                setPreviewImage(mediaConfig.binary_data);
                const realImageFile = base64ToFile(
                  mediaConfig.binary_data,
                  mediaConfig.file_name,
                  mediaConfig.file_type,
                );
                setSelectedFile(realImageFile);
              }
              break;

            case 'VIDEO':
              setHeaderType('video');
              setSelectedOption('video');
              if (
                mediaConfig.binary_data &&
                mediaConfig.binary_data.trim() !== ''
              ) {
                const realVideoFile = base64ToFile(
                  mediaConfig.binary_data,
                  mediaConfig.file_name,
                  mediaConfig.file_type,
                );
                setSelectedFile(realVideoFile);
              }
              break;

            case 'DOCUMENT':
              setHeaderType('document');
              setSelectedOption('document');
              if (
                mediaConfig.binary_data &&
                mediaConfig.binary_data.trim() !== ''
              ) {
                const realDocFile = base64ToFile(
                  mediaConfig.binary_data,
                  mediaConfig.file_name,
                  mediaConfig.file_type,
                );
                setSelectedFile(realDocFile);
              }
              break;

            default:
              setHeaderType('none');
              setSelectedOption('none');
          }
        } else {
          setHeaderType('none');
          setSelectedOption('none');
        }

        // 🔸 BODY Component
        const bodyComponent = components.find(
          (comp: any) => comp.type === 'BODY',
        );
        if (bodyComponent) {
          setBodyText(bodyComponent.text || '');
        }

        // 🔸 FOOTER Component
        const footerComponent = components.find(
          (comp: any) => comp.type === 'FOOTER',
        );
        if (footerComponent) {
          setFooterText(footerComponent.text || '');
        }

        // 🔸 BUTTONS Component
        const buttonComponent = components.find(
          (comp: any) => comp.type === 'BUTTONS',
        );
        if (buttonComponent?.buttons?.length > 0) {
          const transformedRows: RowData[] = buttonComponent.buttons.map(
            (btn: any) => {
              if (btn.type === 'URL') {
                return {
                  buttonType: 'URL',
                  buttonText: btn.text,
                  buttonTypeDropdown: 'static',
                  websiteUrl: btn.url,
                  callPhoneNumber: '',
                  countryCode: '',
                  copyOfferCode: '',
                };
              } else if (btn.type === 'PHONE_NUMBER') {
                const phone = btn.phone_number || '';
                const phoneStr = phone.toString();
                const countryCode =
                  phoneStr.length > 10 ? phoneStr.slice(0, -10) : '';
                const phoneNumber =
                  phoneStr.length > 10 ? phoneStr.slice(-10) : phoneStr;

                return {
                  buttonType: 'PHONE_NUMBER',
                  buttonText: btn.text,
                  buttonTypeDropdown: 'static',
                  callPhoneNumber: phoneNumber,
                  countryCode: countryCode,
                  websiteUrl: '',
                  copyOfferCode: '',
                };
              } else if (btn.type === 'COPY_CODE') {
                return {
                  buttonType: 'COPY_CODE',
                  buttonText: 'Copy',
                  buttonTypeDropdown: 'static',
                  websiteUrl: '',
                  callPhoneNumber: '',
                  countryCode: '',
                  copyOfferCode: btn.example || '',
                };
              } else if (btn.type === 'QUICK_REPLY') {
                return {
                  buttonType: 'QUICK_REPLY',
                  buttonText: btn.text,
                  buttonTypeDropdown: 'static',
                  websiteUrl: '',
                  callPhoneNumber: '',
                  countryCode: '',
                  copyOfferCode: '',
                };
              }

              return {
                buttonType: '',
                buttonText: '',
                buttonTypeDropdown: 'static',
                websiteUrl: '',
                callPhoneNumber: '',
                countryCode: '',
                copyOfferCode: '',
              };
            },
          );

          setRows(transformedRows);
        } else {
          setRows([]);
        }

        console.log('✅ WhatsApp Content loaded from draft:', {
          completeTemplate: templates.whatsappContent,
          mediaConfig: mediaConfig,
          components: components.length,
        });
      } else {
        console.warn('⚠️ WhatsApp template not found in draft');
        // Reset WhatsApp states
        setWhatsappContent(null);
        setMediaConfig({
          file_name: '',
          file_type: '',
          binary_data: '',
          file_length: '',
        });
        setMediaBase64('');
        setFileName('');
        setFileLength('');
        setFileType('');
        setHeaderType('none');
        setSelectedOption('none');
        setBodyText('');
        setFooterText('');
        setRows([]);
      }

      // 🔹 Load SMS Template from Draft
      if (templates.smsContent?.template) {
        const smsTemplate = templates.smsContent.template;
        const smsContent = smsTemplate.template_content;

        console.log('📱 SMS Template Found in Draft:', smsContent);

        // ✅ Set SMS message body
        setBody(smsContent.message || '');

        // ✅ Set parts count from draft
        setPartsCount(smsTemplate.part_count || 1);

        // ✅ Set warning if parts > 1
        setShowWarning(smsTemplate.part_count > 1);

        // ✅ Set complete SMS content to context
        setSmsContent(templates.smsContent);

        console.log('✅ SMS Content loaded from draft:', {
          message: smsContent.message,
          partsCount: smsTemplate.part_count,
          completeTemplate: templates.smsContent,
        });
      } else {
        console.warn('⚠️ SMS template not found in draft');
        // Reset SMS states
        setBody('');
        setPartsCount(1);
        setShowWarning(false);
        setSmsContent(null);
      }

      console.log(
        '✅ Campaign draft retrieved with templates:',
        details.campaign_name,
      );
      return draft;
    } catch (error) {
      setIsCampaignListLoading(false);
      console.error('Error fetching campaign draft:', error);
      return null;
    }
  };

  useEffect(() => {
    console.log('heree', selectedFromCountryISOs);
  }, [selectedFromCountryISOs]);

  useEffect(() => {
    setTimeout(() => {
      document.body.style.pointerEvents = '';
    }, 500);
  }, [isTestModeOpen]);

  // CRUD Actions

  const handleCreateCampaign = async () => {
    const status = await getWalletStatusByWorkspaceId();
    await GetFromCountries();
    // await GetCampaignDraftByWorkspaceId();
    setIsCampaignListLoading(false);
    if (!status) {
      toast.toast({
        title: 'Alert',
        description:
          'Your wallet is not paired. Please pair your wallet to create a campaign.',
      });
      return;
    }
    // if (isUpdateMode || isViewMode) {
    resetCampaign();
    resetSMSContent();
    resetWhatsappContent();
    setUpdateCampaignId(null);
    setIsUpdateMode(false);
    setIsViewMode(false);
    setIsDraftMode(false);
    // }
    dispatch(setCreateBreadCrumb(true));
    navigate('/navbar/createcampaign');
  };
  const handleEdit = (campaignId: number) =>
    navigate('/navbar/createcampaign', { state: { campaignId } });
  const handleView = (campaignId: number) =>
    navigate('/navbar/createcampaign', {
      state: { viewModecampaignId: campaignId },
    });
  const handleInternalOpenDialog = (
    campaignId: number,
    campaignName: string,
  ) => {
    setCampaignToDelete(campaignId);
    setCampaignNameToDelete(campaignName);
    setTimeout(() => setInternalDialogOpen(true), 0);
  };

  // const toggleCampaignStatus = async (campaignId: number, action: string) => {
  //   if (!campaignId || !action) return;

  //   try {
  //     const response = await axios.put(
  //       `${apiUrlAdvAcc}/ToggleCampaignPauseResume`,
  //       {
  //         campaignId: campaignId,
  //         action: action,
  //       }
  //     );

  //     if (response.data.status === "Success") {
  //       getCampaignList();

  //       toast.toast({
  //         title: "Success",
  //         description: "The campaign status updated successfully",
  //       });
  //     } else {
  //       toast.toast({
  //         title: "Failur",
  //         description: "Failed to update the campaign status",
  //       });
  //     }
  //   } catch (error) {
  //     toast.toast({
  //       title: "Failure",
  //       description:
  //         "Something went wrong while trying to update the campaign status",
  //     });
  //   } finally {
  //   }
  // };
  const toggleCampaignStatus = async (campaignId: number, action: string) => {
    if (!campaignId || !action) return;

    let toggleSuccess = false; // ✅ Flag to track toggle API result

    try {
      const response = await axios.put(
        `${apiUrlAdvAcc}/ToggleCampaignPauseResume`,
        {
          campaignId: campaignId,
          action: action,
        },
      );

      if (response.data.status === 'Success') {
        toggleSuccess = true;

        getCampaignList();

        toast.toast({
          title: 'Success',
          description: 'The campaign status updated successfully',
        });
      } else {
        toast.toast({
          title: 'Failure',
          description: 'Failed to update the campaign status',
        });
      }
    } catch (error) {
      toast.toast({
        title: 'Failure',
        description:
          'Something went wrong while trying to update the campaign status',
      });
    } finally {
      // 📝 Map action to readable values for audit log
      const newStatus = action === 'paused' ? 'Paused' : 'Resumed';
      const comments =
        action === 'paused'
          ? 'Campaign paused by user'
          : 'Campaign resumed by user';
      const actionLabel =
        action === 'paused' ? 'Campaign Paused' : 'Campaign Resumed';

      const auditDto = {
        userAccountId: accountId,
        campaignId: campaignId,
        advertiserWorkspaceId: workspaceId,
        action: actionLabel, // ✅ More readable action for audit
        actionPage: 'CampaignList',
        status: toggleSuccess ? 'Success' : 'Failure',
        beforeData: null, // will be fetched in API
        afterData: JSON.stringify({ status: newStatus }),
        ipAddress: null,
        comments: comments,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      try {
        await axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, auditDto);
        // ⚠️ Silent failure as decided
      } catch (auditError) {
        console.error('Audit logging failed', auditError);
      }
    }
    return toggleSuccess; // ✅ Return the flag
  };

  const DeleteCampaignDraftByWorkspaceIdAndDraftId = async (
    workspaceId: number,
    draftId: number,
  ) => {
    try {
      const response = await axios.delete(
        `${apiUrlAdvAcc}/DeleteCampaignDraftByWorkspaceIdAndDraftId?workspaceId=${workspaceId}&draftId=${draftId}`,
      );

      if (response.data?.status === 'Success') {
        console.log(
          `Draft deleted for workspaceId: ${workspaceId}, draftId: ${draftId}, deletedCount: ${response.data.deletedCount}`,
        );
        toast.toast({
          title: 'Success',
          description: 'Draft Deleted Successfully',
        });
        getDraftList();
      } else {
        console.warn(
          `Failed to delete draft for workspaceId: ${workspaceId}, draftId: ${draftId}`,
          response.data,
        );
        toast.toast({
          title: 'Failure',
          description: 'Failed to delete draft',
        });
        getDraftList();
      }
    } catch (error) {
      console.error(
        'Error deleting campaign draft by workspace ID and draft ID:',
        error,
      );
      toast.toast({
        title: 'Failure',
        description: 'Failed to delete draft',
      });
      getDraftList();
    }
  };

  const confirmDelete = async () => {
    if (!campaignToDelete) return;
    setIsApiExecuting(true);
    try {
      const response = await axios.delete(
        `${apiUrlAdvAcc}/DeleteCampaignById`,
        {
          params: {
            CampaignId: campaignToDelete,
            UserAccountId: accountId,
            ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
          },
        },
      );

      const { status, status_Description } = response.data;

      if (status === 'Success') {
        await triggerCampaignDeletionWebhookn8n(
          campaignToDelete,
          campaignNameToDelete,
        );
        setInternalDialogOpen(false);
        getCampaignList();
        toast.toast({
          title: 'Success',
          description:
            status_Description || 'The campaign was deleted successfully',
        });
      } else {
        setInternalDialogOpen(false);
        getCampaignList();
        toast.toast({
          title: 'Failure',
          description: status_Description || 'Failed to delete campaign',
        });
      }
    } catch (error) {
      setInternalDialogOpen(false);
      getCampaignList();
      toast.toast({
        title: 'Failure',
        description: 'Something went wrong while deleting the campaign.',
      });
      console.error('Delete campaign error:', error);
    } finally {
      setIsApiExecuting(false);
    }
  };

  const triggerCampaignDeletionWebhookn8n = async (
    campaignId: any,
    campaignName: any,
  ) => {
    try {
      const payload = {
        campaignID: campaignId,
        campaignName: campaignName,
        advertiserID: String(accountId),
        advertiserName: '',
        workspaceID: workspaceId,
        workspaceName: workspaceName,
        request_type: 'adv_delete_campaign',
        advertiser_email: Email,
      };

      const response = await axios.post(
        `${apiUrlAdvAcc}/N8NAdvCampaignDeletionWebhook`,
        payload,
      );
      if (response.status !== 200) {
        console.error('❌ Webhook Trigger Failed');
      } else {
        console.log('✅ Webhook Triggered Successfully');
      }
    } catch (error) {
      console.error('❗ Error in triggerN8NWebhook', error);
    }
  };

  debugger;
  const handleStatusNavigate = (campaign_id: number): void => {
    navigate('/navbar/campaignstatusprogress', {
      state: { campaign_id },
    });
  };

  // // Pagination
  // const totalPages: number = Math.ceil(totalDraftCount / rowsPerPage);

  // Pagination
  const totalPages: number = Math.max(
    1,
    Math.ceil(
      (activeTab === 'Draft' ? totalDraftCount : totalCount) / rowsPerPage,
    ),
  );

  // Export
  const handleExportButtonClick = async () => {
    if (!workspaceId || !apiUrlAdvAcc) return;

    setIsExporting(true);
    try {
      const params: any = {
        workspaceId,
        searchTerm: debouncedSearchTerm || undefined,
        filter: filterData.filter !== 'None' ? filterData.filter : undefined,
        subFilter: filterData.filter !== 'None' ? filterData.value : undefined,
      };
      if (dateRange?.from && dateRange?.to) {
        params.startDate = format(dateRange.from, 'yyyy-MM-dd');
        params.endDate = format(dateRange.to, 'yyyy-MM-dd');
      }

      const response = await axios.get(
        `${apiUrlAdvAcc}/GetCampaignListbyWorkspaceIdWithOutPagination/${workspaceId}`,
        { params },
      );

      if (response.data.status !== 'Success') {
        return;
      }

      const fullCampaignList: Campaign[] = response.data.campaignList || [];

      const filteredData = fullCampaignList.map((c) => ({
        campaign_id: c.campaign_id,
        campaign_name: c.campaign_name,
        channels: (c.channels || []).filter(Boolean).join(', '),
        status: c.status,
        start_date: c.start_date,
        end_date: c.end_date,
        total_traveller_count: c.traveller_count_total,
        total_targeted_traveller_count: c.total_sent_count,
        total_messages_sent: c.total_messages_sent,
        total_delivered_count: c.total_delivery_count,
        delivered_whatsapp_count: c.delivered_whatsapp_count,
        delivered_sms_count: c.delivered_sms_count,
        sent_test_mode_count: c.sent_test_mode_count,
        delivered_test_mode_count: c.delivered_test_mode_count,
      }));
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Campaign_List');
      XLSX.writeFile(workbook, 'CampaignList.xlsx');
    } catch (error) {
      console.error('Error exporting campaign list:', error);
    } finally {
      setIsExporting(false);
    }
  };

  const handleDraftTabClick = () => {
    setActiveTab('Draft'); // switch tab
    setCurrentPage(1); // reset pagination
    setDebouncedSearchTerm(''); // reset search
    setSearchTerm('');
    setDateRange({ from: undefined, to: undefined }); // clear date filters
    setRowsPerPage(10);
    getDraftList(); // call API
  };

  const handleListTabClick = () => {
    // switch tab
    setCurrentPage(1); // reset pagination
    setDebouncedSearchTerm(''); // reset search
    setSearchTerm('');
    setDateRange({ from: undefined, to: undefined }); // clear date filters
    setRowsPerPage(10);
  };

  if (isLoading) {
    return (
      <div className='flex flex-col items-center justify-center h-[500px]'>
        <CircularProgress color='primary' />
      </div>
    );
  }
  return (
    <div>
      {isCampaignListLoading ? (
        <>
          <div className='loading-overlay'>
            <CircularProgress color='primary' />
          </div>
        </>
      ) : (
        <>
          <div className='fixed flex justify-end items-end right-0 top-[-15px] z-20 p-4 mr-2'>
            {userPermissions.includes('ADV_Campaigns_Create') && (
              <Button
                onClick={handleCreateCampaign}
                className='w-36 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px] '
              >
                Create Campaign
              </Button>
            )}
          </div>
          <div className='mt-4'>
            <div className='flex flex-wrap items-center justify-between gap-4 -mt-6'>
              <div className='flex flex-wrap justify-start w-full md:w-auto gap-10'>
                <div>
                  <Input
                    placeholder={`Search ${activeTab === 'Draft' ? 'drafts' : 'campaigns'} by name...`}
                    className='w-full md:w-[350px] text-[14px] font-normal text-[#171717] !mt-0'
                    value={searchTerm}
                    onChange={(e) => {
                      const v = e.target.value;
                      setSearchTerm(v);
                      if (currentPage !== 1) setCurrentPage(1); // <-- force page 1 on any search
                    }}
                  />
                </div>
              </div>

              <div
                className={`flex flex-wrap items-center justify-end w-full md:w-auto ${
                  activeTab === 'List' ? 'gap-10' : ''
                }`}
              >
                {activeTab === 'List' ? (
                  <>
                    <div className='flex-shrink-0 -mr-4 '>
                      <AdvertiserCampaignListDropdown
                        filterData={filterData}
                        setFilterData={setFilterData}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className='flex-shrink-0 mr-4'></div>
                  </>
                )}

                <div className='flex-shrink-0 -mr-4'>
                  <DatePickerWithRange
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    setInitialCampaign={setInitialCampaign}
                    setIsClearingDate={setIsClearingDate}
                  />
                </div>

                {activeTab === 'List' ? (
                  <>
                    <div className='flex-shrink-0'>
                      <Button
                        variant='outline'
                        className='w-24 text-[#020617] !mt-0'
                        onClick={handleExportButtonClick}
                        disabled={isExporting}
                      >
                        {isExporting ? 'Exporting...' : 'Export'}
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='mr-4'></div>
                  </>
                )}
              </div>
            </div>

            <div className='mt-6'>
              {/* <div className="flex border rounded-t-md overflow-hidden w-fit bg-white shadow-sm">
         
              <button
                onClick={() => setActiveTab('List')}
                className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                  activeTab === 'List'
                    ? 'bg-[#3A85F7] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                List
              </button>

              <button
                onClick={handleDraftTabClick}
                className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                  activeTab === 'Draft'
                    ? 'bg-[#3A85F7] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Drafts
              </button>
            </div> */}
              {/* <AdvertiserCampaignListDropdown
                filterData={filterData}
                setFilterData={setFilterData}
              /> */}

              <div className='flex overflow-hidden w-full justify-start mb-1'>
                <Tabs
                  defaultValue='List'
                  value={activeTab}
                  onValueChange={setActiveTab}
                  className='flex'
                >
                  <TabsList>
                    <TabsTrigger
                      value='List'
                      onClick={handleListTabClick}
                      className='px-8'
                    >
                      List
                    </TabsTrigger>
                    <TabsTrigger
                      value='Draft'
                      onClick={handleDraftTabClick}
                      className='px-8'
                    >
                      Drafts
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
              </div>

              <div className='rounded-md border p-2'>
                <div className='max-h-[60vh] overflow-y-auto'>
                  <Table
                    className='rounded-xl whitespace-nowrap border-gray-200'
                    style={{ color: '#020202', fontSize: '15px' }}
                  >
                    <TableHeader>
                      <TableRow className='sticky top-0 z-10 bg-white hover:bg-white'>
                        {activeTab === 'Draft' ? (
                          <>
                            {/* Draft tab headers - simplified for available data */}
                            <TableHead className='pl-6 pr-3 py-3 font-medium text-left'>
                              <div className='flex items-center gap-2'>
                                <span>Campaign name</span>
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium w-[140px] text-left'>
                              <div className='flex items-center gap-2'>
                                Channel
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium text-center'>
                              <div className='flex items-center justify-center gap-2'>
                                Total Travellers
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium text-left'>
                              <div className='flex items-center gap-2'>
                                Created Date
                              </div>
                            </TableHead>
                            <TableHead className='w-12 py-3'></TableHead>
                          </>
                        ) : (
                          <>
                            {/* Full List tab headers */}
                            <TableHead className='pl-6 pr-3 py-3 font-medium'>
                              <div className='flex items-center gap-3'>
                                <input
                                  type='checkbox'
                                  className={`accent-gray-700`}
                                  checked={isAllSelected}
                                  onChange={handleSelectAll}
                                />
                                <span>Campaign name</span>
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByCampaignName')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium w-[140px]'>
                              <div className='flex items-center gap-2'>
                                Channel
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Campaign Status
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByCampaignStatus')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Setup Preview
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Schedule
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByCampaignDate')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Total Travellers
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByTotalTravellers')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              {/* <div className="flex items-center gap-2">
                                People Reached
                                <CaretSortIcon
                                  onClick={() => sortCampaignList("ByCampaignSent")}
                                  className="cursor-pointer"
                                />
                              </div> */}
                              <div className='flex items-center gap-2'>
                                Targeted Travellers
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByCampaignSent')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Messages Sent
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByMessagesSent')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='py-3 px-3 font-medium'>
                              <div className='flex items-center gap-2'>
                                Created Date
                                <CaretSortIcon
                                  onClick={() =>
                                    sortCampaignList('ByCreatedDate')
                                  }
                                  className='cursor-pointer'
                                />
                              </div>
                            </TableHead>
                            <TableHead className='w-12 py-3'></TableHead>
                          </>
                        )}
                      </TableRow>
                    </TableHeader>

                    <TableBody>
                      {activeTab === 'Draft' ? (
                        <>
                          {draftLoading || draftList.length === 0 ? (
                            <TableRow>
                              <TableCell
                                colSpan={5}
                                className='text-center py-4 text-gray-500 font-medium'
                              >
                                {draftLoading
                                  ? 'Loading...'
                                  : searchTerm.trim() !== ''
                                    ? 'No drafts found for the searched item.'
                                    : 'No draft campaigns found.'}
                              </TableCell>
                            </TableRow>
                          ) : (
                            draftList.map((draft) => (
                              <TableRow key={draft.draft_id}>
                                <TableCell className='pl-6 pr-3 py-4 text-left align-middle'>
                                  <span className='text-black text-[14px] cursor-pointer font-normal'>
                                    {draft.campaign_name}
                                  </span>
                                </TableCell>
                                <TableCell className='py-4 px-3 text-left align-middle w-[140px]'>
                                  {/* {draft.channels?.join(", ") || "-"} */}
                                  <ChannelCarousel
                                    channels={draft.channels || []}
                                  />
                                </TableCell>
                                <TableCell className='py-4 px-3 text-center align-middle'>
                                  {draft.total_travellers || 0}
                                </TableCell>
                                <TableCell className='py-4 px-3 text-left align-middle'>
                                  {draft.created_time
                                    ? (() => {
                                        const iso = /Z|[+\-]\d{2}:\d{2}$/.test(
                                          draft.created_time,
                                        )
                                          ? draft.created_time
                                          : `${draft.created_time}Z`;

                                        const { localDate } = convertUTCToLocal(
                                          iso,
                                          workspaceTimezone,
                                        );

                                        const localTimeWithSeconds =
                                          new Intl.DateTimeFormat('en-GB', {
                                            timeZone:
                                              workspaceTimezone || 'UTC',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false,
                                          }).format(new Date(iso));

                                        return `${localDate} - ${localTimeWithSeconds}`;
                                      })()
                                    : '-'}
                                </TableCell>
                                <TableCell className='text-right pr-4 py-4 align-middle'>
                                  {/* Draft actions can be added here if needed */}

                                  {userPermissions.includes(
                                    'ADV_Campaigns_Edit',
                                  ) && (
                                    <DropdownMenu>
                                      <DropdownMenuTrigger asChild>
                                        <DotsHorizontalIcon className='cursor-pointer w-5 h-5' />
                                      </DropdownMenuTrigger>

                                      <DropdownMenuContent>
                                        <DropdownMenuItem
                                          className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                          // onClick={() => GetCampaignDraftByWorkspaceId(workspaceId, draft.draft_id)}
                                          onClick={() => {
                                            GetCampaignDraftByWorkspaceId(
                                              workspaceId,
                                              draft.draft_id,
                                            );

                                            if (isUpdateMode || isViewMode) {
                                              resetCampaign();
                                              resetSMSContent();
                                              resetWhatsappContent();
                                              setUpdateCampaignId(null);
                                              setIsUpdateMode(false);
                                              setIsViewMode(false);
                                              setIsDraftMode(false);
                                            }

                                            dispatch(setCreateBreadCrumb(true));
                                            navigate('/navbar/createcampaign', {
                                              state: {
                                                draft_id: draft.draft_id,
                                              },
                                            });
                                          }}
                                        >
                                          Create
                                        </DropdownMenuItem>

                                        <DropdownMenuItem
                                          className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                          onClick={() => {
                                            DeleteCampaignDraftByWorkspaceIdAndDraftId(
                                              workspaceId,
                                              draft.draft_id,
                                            );
                                            getDraftList();
                                          }}
                                        >
                                          Delete
                                        </DropdownMenuItem>
                                      </DropdownMenuContent>
                                    </DropdownMenu>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </>
                      ) : (
                        <>
                          {campaignList.length > 0 && !campaignLoading ? (
                            campaignList.map((campaign) => {
                              const isSelected = checkboxSelectedRows.includes(
                                campaign.campaign_id,
                              );

                              const canEdit =
                                (campaign.status === 'active' &&
                                  campaign.admin_approval === 'rejected') ||
                                (campaign.status === 'sandbox' &&
                                  campaign.admin_approval === 'rejected') ||
                                (campaign.status === 'sandbox' &&
                                  campaign.status_preview === 'Live');

                              return (
                                <TableRow
                                  key={campaign.campaign_id}
                                  className={isSelected ? 'bg-gray-200' : ''}
                                >
                                  {/* Checkbox + Campaign Name Cell */}
                                  <TableCell className='pl-6 pr-3 py-4'>
                                    <div className='flex items-center gap-3'>
                                      <input
                                        type='checkbox'
                                        className='accent-gray-700'
                                        checked={isSelected}
                                        onChange={() =>
                                          handleCheckboxRowSelect(
                                            campaign.campaign_id,
                                          )
                                        }
                                      />
                                      <span className='text-black text-[14px] cursor-pointer font-normal'>
                                        {campaign.campaign_name}
                                      </span>
                                    </div>
                                  </TableCell>
                                  {/* Channel Cell with Carousel */}
                                  <TableCell className='py-4 px-3 align-middle w-[140px]'>
                                    <ChannelCarousel
                                      channels={campaign.channels || []}
                                    />
                                  </TableCell>
                                  {/* Status */}
                                  <TableCell className='py-4 px-3 align-middle text-left'>
                                    {campaign.status}
                                  </TableCell>
                                  <TableCell className='py-4 px-3 align-middle text-left'>
                                    <StatusPreviewBadge
                                      value={campaign.status_preview}
                                      onClick={() =>
                                        handleStatusNavigate(
                                          campaign.campaign_id,
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell className='py-4 px-3 align-middle'>
                                    <div className='flex items-center gap-2'>
                                      {campaign.start_date ? (
                                        <>
                                          {
                                            convertUTCToLocal(
                                              campaign.start_date,
                                              workspaceTimezone,
                                            ).localDate
                                          }
                                          <ArrowRightIcon />
                                          {campaign.end_date
                                            ? convertUTCToLocal(
                                                campaign.end_date,
                                                workspaceTimezone,
                                              ).localDate
                                            : '-'}
                                        </>
                                      ) : (
                                        '-'
                                      )}
                                    </div>
                                  </TableCell>
                                  {/* Total Travellers */}
                                  <TableCell className='py-4 px-3 text-center align-middle'>
                                    {typeof campaign.traveller_count_total !==
                                    'undefined'
                                      ? campaign.traveller_count_total
                                      : '-'}
                                  </TableCell>
                                  {/* Sent */}
                                  <TableCell className='py-4 px-3 text-left align-middle'>
                                    {typeof campaign.total_sent_count !==
                                    'undefined'
                                      ? campaign.total_sent_count
                                      : '-'}
                                  </TableCell>
                                  <TableCell className='py-4 px-3 text-left align-middle'>
                                    {typeof campaign.total_messages_sent !==
                                    'undefined'
                                      ? campaign.total_messages_sent
                                      : '-'}
                                  </TableCell>
                                  <TableCell className='py-4 px-3 text-left align-middle'>
                                    {campaign.created_date
                                      ? (() => {
                                          const iso =
                                            /Z|[+\-]\d{2}:\d{2}$/.test(
                                              campaign.created_date,
                                            )
                                              ? campaign.created_date
                                              : `${campaign.created_date}Z`;

                                          const { localDate } =
                                            convertUTCToLocal(
                                              iso,
                                              workspaceTimezone,
                                            );

                                          const localTimeWithSeconds =
                                            new Intl.DateTimeFormat('en-GB', {
                                              timeZone:
                                                workspaceTimezone || 'UTC',
                                              hour: '2-digit',
                                              minute: '2-digit',
                                              second: '2-digit',
                                              hour12: false,
                                            }).format(new Date(iso));

                                          return `${localDate} - ${localTimeWithSeconds}`;
                                        })()
                                      : '-'}
                                  </TableCell>
                                  {/* Menu */}
                                  <TableCell className='text-right pr-4 py-4 align-middle'>
                                    {userPermissions.includes(
                                      'ADV_Campaigns_Edit',
                                    ) && (
                                      <DropdownMenu>
                                        <DropdownMenuTrigger asChild>
                                          <DotsHorizontalIcon
                                            onClick={() =>
                                              setOpenMenuRowId(
                                                openMenuRowId ===
                                                  campaign.campaign_id
                                                  ? null
                                                  : campaign.campaign_id,
                                              )
                                            }
                                            className='cursor-pointer w-5 h-5'
                                          />
                                        </DropdownMenuTrigger>
                                        {openMenuRowId ===
                                          campaign.campaign_id && (
                                          <DropdownMenuContent
                                            align='end'
                                            className='w-40 bg-white shadow-lg rounded p-1 text-sm z-[9999]'
                                          >
                                            <DropdownMenuItem
                                              onClick={() =>
                                                handleEdit(campaign.campaign_id)
                                              }
                                              className={`px-3 py-2 ${
                                                canEdit
                                                  ? 'hover:bg-gray-100 cursor-pointer'
                                                  : 'text-gray-400 cursor-not-allowed'
                                              }`}
                                              disabled={!canEdit}
                                            >
                                              Edit
                                            </DropdownMenuItem>

                                            <DropdownMenuItem
                                              onClick={() =>
                                                handleView(campaign.campaign_id)
                                              }
                                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                            >
                                              View
                                            </DropdownMenuItem>
                                            <DropdownMenuItem
                                              onClick={() => {
                                                setTestModeCampaignId(
                                                  campaign.campaign_id,
                                                );
                                                setIsTestModeOpen(true);
                                              }}
                                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                              disabled={
                                                campaign.status !== 'sandbox' ||
                                                campaign.status_preview !==
                                                  'Live'
                                              }
                                            >
                                              Test Campaign
                                            </DropdownMenuItem>

                                            <DropdownMenuItem
                                              // onClick={() => toggleCampaignStatus(campaign.campaign_id, "active")}
                                              onClick={async () => {
                                                const success =
                                                  await toggleCampaignStatus(
                                                    campaign.campaign_id,
                                                    'active',
                                                  );

                                                if (success) {
                                                  await axios.post(
                                                    `${apiUrlAdminAcc}/InsertAuditHistory`,
                                                    {
                                                      UserAccountId: accountId,
                                                      CampaignId:
                                                        campaign.campaign_id,
                                                      AdvertiserWorkspaceId:
                                                        workspaceId,
                                                      Action:
                                                        'Campaign Promoted To Live',
                                                      ActionPage:
                                                        'Advertiser Campaign List',
                                                      Status: 'active',
                                                      BeforeData: null,
                                                      AfterData: null,
                                                      Comments:
                                                        'Campaign promoted to live',
                                                      ImpersonatorUserAccountId:
                                                        isImpersonated
                                                          ? impersonatorAID
                                                          : null,
                                                    },
                                                  );
                                                }
                                              }}
                                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                              // disabled={campaign.status !== "sandbox"}
                                              disabled={
                                                campaign.status !== 'sandbox' ||
                                                campaign.status_preview !==
                                                  'Live'
                                              }
                                            >
                                              Move to Live
                                            </DropdownMenuItem>

                                            <DropdownMenuItem
                                              onClick={() =>
                                                handleInternalOpenDialog(
                                                  campaign.campaign_id,
                                                  campaign.campaign_name,
                                                )
                                              }
                                              disabled={
                                                campaign.admin_approval ===
                                                'approved'
                                              }
                                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed'
                                            >
                                              Delete
                                            </DropdownMenuItem>
                                            {campaign.status === 'active' && (
                                              <DropdownMenuItem
                                                onClick={() =>
                                                  toggleCampaignStatus(
                                                    campaign.campaign_id,
                                                    'paused',
                                                  )
                                                }
                                                className='px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed'
                                              >
                                                Pause
                                              </DropdownMenuItem>
                                            )}

                                            {campaign.status === 'paused' && (
                                              <DropdownMenuItem
                                                onClick={() =>
                                                  toggleCampaignStatus(
                                                    campaign.campaign_id,
                                                    'active',
                                                  )
                                                }
                                                className='px-3 py-2 hover:bg-gray-100 cursor-pointer data-[disabled=true]:text-gray-400 data-[disabled=true]:cursor-not-allowed'
                                              >
                                                Resume
                                              </DropdownMenuItem>
                                            )}
                                            <DropdownMenuItem
                                              onClick={() => {
                                                setOpenMenuRowId(null);
                                                setDetailedSummaryModal({
                                                  isOpen: true,
                                                  campaign: campaign,
                                                });
                                              }}
                                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                                            >
                                              View Detailed Summary
                                            </DropdownMenuItem>
                                          </DropdownMenuContent>
                                        )}
                                      </DropdownMenu>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={10}
                                className='text-center py-4 text-gray-500 font-medium'
                              >
                                {campaignLoading
                                  ? 'Loading...'
                                  : searchTerm.trim() !== ''
                                    ? 'No campaigns found for the searched item.'
                                    : 'No campaigns found.'}
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </div>
              </div>

              {/* Pagination controls */}
              <div className='flex justify-between items-center mt-4'>
                <div className='flex items-center space-x-2 text-gray-500 text-sm '>
                  {/* <span>{`${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
                    currentPage * rowsPerPage,
                    totalCount
                  )} of ${totalCount} row(s) selected`}</span> */}
                  <span>
                    {(activeTab === 'Draft' ? totalDraftCount : totalCount) ===
                    0
                      ? '0 of 0 row(s) selected'
                      : `${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
                          currentPage * rowsPerPage,
                          activeTab === 'Draft' ? totalDraftCount : totalCount,
                        )} of ${activeTab === 'Draft' ? totalDraftCount : totalCount} row(s) selected`}
                  </span>
                </div>
                <div className='flex items-center space-x-4 font-medium text-sm'>
                  <span className='text-[#020617] font-medium text-[14px]'>
                    Rows per page
                  </span>
                  <div className='relative inline-block ml-2'>
                    <select
                      disabled={campaignList.length === 0}
                      className={`cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 ${campaignList.length === 0 ? 'cursor-not-allowed bg-gray-100' : ''}`}
                      style={{
                        width: '60px',
                        height: '30px',
                        textAlign: 'left',
                        fontSize: '12px',
                        fontWeight: '400',
                        borderColor: '#E5E7EB',
                        boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
                      }}
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[5, 10, 20].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                    <CaretSortIcon className='absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4' />
                  </div>
                  <div className='ml-4 mr-4'>
                    <span className='text-[#020617] text-[14px] font-medium'>
                      {(activeTab === 'Draft'
                        ? totalDraftCount
                        : totalCount) === 0
                        ? 'Page 1 of 1'
                        : `Page ${currentPage} of ${totalPages}`}
                    </span>
                  </div>
                  <div className='flex items-center gap-2'>
                    <button
                      disabled={
                        currentPage === 1 ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                      }
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                        currentPage === 1 ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                          ? 'cursor-not-allowed bg-gray-100'
                          : 'hover:bg-gray-200'
                      }`}
                      onClick={() => setCurrentPage(1)}
                    >
                      «
                    </button>
                    <button
                      disabled={
                        currentPage === 1 ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                      }
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                        currentPage === 1 ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                          ? 'cursor-not-allowed bg-gray-100'
                          : 'hover:bg-gray-200'
                      }`}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      ‹
                    </button>
                    <button
                      disabled={
                        currentPage === totalPages ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                      }
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                        currentPage === totalPages ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                          ? 'cursor-not-allowed bg-gray-100'
                          : 'hover:bg-gray-200'
                      }`}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      ›
                    </button>
                    <button
                      disabled={
                        currentPage === totalPages ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                      }
                      className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                        currentPage === totalPages ||
                        (activeTab === 'Draft'
                          ? totalDraftCount
                          : totalCount) === 0
                          ? 'cursor-not-allowed bg-gray-100'
                          : 'hover:bg-gray-200'
                      }`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      »
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Delete Dialog */}
          <Dialog
            open={isInternalDialogOpen}
            onClose={() => setInternalDialogOpen(false)}
          >
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this campaign?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant='outline'
                className='w-24'
                onClick={() => setInternalDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className='w-24'
                onClick={confirmDelete}
                autoFocus
                disabled={isApiExecuting}
              >
                {isApiExecuting ? 'Deleting' : 'Delete'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Detailed Summary Dialog */}
          <Dialog
            open={detailedSummaryModal.isOpen}
            onClose={() =>
              setDetailedSummaryModal({ isOpen: false, campaign: null })
            }
            aria-labelledby='detailed-summary-title'
            maxWidth='xs'
            fullWidth={false}
            PaperProps={{
              sx: {
                borderRadius: '10px',
                p: 1,
                width: 420,
                maxWidth: 'calc(100% - 32px)',
              },
            }}
          >
            <DialogTitle id='detailed-summary-title' sx={{ pb: '12px' }}>
              <div className='text-left text-base font-semibold text-gray-900'>
                Campaign Name :{' '}
                <span className='text-[#3A85F7]'>
                  {detailedSummaryModal.campaign?.campaign_name}
                </span>
              </div>
            </DialogTitle>

            <DialogContent sx={{ pt: 0 }}>
              <div className='space-y-5'>
                {/* Campaign Section */}
                <div>
                  <h3 className='text-sm font-semibold text-gray-800 mb-2'>
                    Campaign
                  </h3>

                  <div className='space-y-2'>
                    {detailedSummaryModal.campaign?.channels?.includes(
                      'WhatsApp',
                    ) && (
                      <div
                        className='flex justify-between items-center p-3 rounded-lg'
                        style={{
                          backgroundColor: 'rgba(71, 158, 152, 0.10)',
                          border: '1px solid #479E98',
                        }}
                      >
                        <div className='flex items-center gap-2'>
                          <div
                            className='w-3 h-3 rounded-full'
                            style={{ backgroundColor: '#479E98' }}
                          />
                          <span className='text-sm font-medium'>
                            WhatsApp Delivered
                          </span>
                        </div>

                        <span
                          className='font-semibold'
                          style={{ color: '#479E98' }}
                        >
                          {detailedSummaryModal.campaign
                            ?.delivered_whatsapp_count || 0}
                        </span>
                      </div>
                    )}

                    {detailedSummaryModal.campaign?.channels?.includes(
                      'SMS',
                    ) && (
                      <div
                        className='flex justify-between items-center p-3 rounded-lg'
                        style={{
                          backgroundColor: 'rgba(223, 165, 72, 0.12)',
                          border: '1px solid #DFA548',
                        }}
                      >
                        <div className='flex items-center gap-2'>
                          <div
                            className='w-3 h-3 rounded-full'
                            style={{ backgroundColor: '#DFA548' }}
                          />
                          <span className='text-sm font-medium'>
                            SMS Delivered
                          </span>
                        </div>

                        <span
                          className='font-semibold'
                          style={{ color: '#DFA548' }}
                        >
                          {detailedSummaryModal.campaign?.delivered_sms_count ||
                            0}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Test Mode Section */}
                <div>
                  <h3 className='text-sm font-semibold text-gray-800 mb-2'>
                    Test Mode
                  </h3>

                  <div className='space-y-2'>
                    {/* Test Mode Sent */}
                    <div
                      className='flex justify-between items-center p-3 rounded-lg'
                      style={{
                        backgroundColor: 'rgba(249, 115, 22, 0.10)',
                        border: '1px solid #F97316',
                      }}
                    >
                      <div className='flex items-center gap-2'>
                        <div
                          className='w-3 h-3 rounded-full'
                          style={{ backgroundColor: '#F97316' }}
                        />
                        <span className='text-sm font-medium text-gray-700'>
                          Sent Messages
                        </span>
                      </div>

                      <span
                        className='font-semibold'
                        style={{ color: '#F97316' }}
                      >
                        {detailedSummaryModal.campaign?.sent_test_mode_count}
                      </span>
                    </div>

                    {/* Test Mode Delivered */}
                    <div
                      className='flex justify-between items-center p-3 rounded-lg'
                      style={{
                        backgroundColor: 'rgba(236, 72, 153, 0.10)',
                        border: '1px solid #EC4899',
                      }}
                    >
                      <div className='flex items-center gap-2'>
                        <div
                          className='w-3 h-3 rounded-full'
                          style={{ backgroundColor: '#EC4899' }}
                        />
                        <span className='text-sm font-medium text-gray-700'>
                          Delivered Messages
                        </span>
                      </div>

                      <span
                        className='font-semibold'
                        style={{ color: '#EC4899' }}
                      >
                        {
                          detailedSummaryModal.campaign
                            ?.delivered_test_mode_count
                        }
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContent>

            <DialogActions sx={{ pt: '8px', justifyContent: 'center' }}>
              <Button
                variant='outline'
                onClick={() =>
                  setDetailedSummaryModal({ isOpen: false, campaign: null })
                }
                className='w-20 cursor-pointer'
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <TestModeDialog
            open={isTestModeOpen}
            onOpenChange={setIsTestModeOpen}
            campaignId={testModeCampaignId}
          />
        </>
      )}
    </div>
  );
};

export default CampaignList;
